import type { FC } from 'react'

interface Props {
  className?: string
}

export const CurieLogo: FC<Props> = ({ className }) => {
  return (
    <svg
      className={className}
      width='93'
      height='31'
      viewBox='0 0 93 31'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M83.9296 30.2482C82.4583 30.2482 81.1315 29.9986 79.9493 29.4994C78.7933 29.0002 77.7949 28.2909 76.9542 27.3713C76.1397 26.4255 75.5092 25.3089 75.0625 24.0215C74.6159 22.7079 74.3926 21.2498 74.3926 19.6471C74.3926 18.0182 74.6159 16.547 75.0625 15.2333C75.5354 13.9197 76.1791 12.8031 76.9936 11.8836C77.808 10.9377 78.7801 10.2152 79.9098 9.71606C81.0658 9.21688 82.3401 8.96729 83.7325 8.96729C85.0987 8.96729 86.3335 9.21688 87.437 9.71606C88.5667 10.2152 89.5257 10.9115 90.3138 11.8047C91.102 12.6717 91.7063 13.7095 92.1267 14.9181C92.547 16.1266 92.7572 17.4534 92.7572 18.8984V20.3959H77.7029V21.3417C77.7029 22.235 77.8474 23.0626 78.1364 23.8245C78.4254 24.5864 78.8327 25.2432 79.3581 25.795C79.9098 26.3467 80.5667 26.7802 81.3286 27.0954C82.1168 27.3844 82.9838 27.5289 83.9296 27.5289C85.2958 27.5289 86.478 27.2137 87.4764 26.5831C88.4748 25.9526 89.2367 25.0856 89.7621 23.9821L92.0872 25.5585C91.483 26.9247 90.4715 28.0544 89.0527 28.9477C87.6603 29.8147 85.9526 30.2482 83.9296 30.2482ZM83.7325 11.5683C82.8655 11.5683 82.0642 11.7259 81.3286 12.0412C80.5929 12.3565 79.9493 12.79 79.3975 13.3417C78.8721 13.8934 78.4517 14.5502 78.1364 15.3121C77.8474 16.0478 77.7029 16.8622 77.7029 17.7555V18.0314H89.368V17.5979C89.368 16.7046 89.2235 15.8901 88.9345 15.1545C88.6718 14.4189 88.2908 13.7883 87.7917 13.2629C87.3187 12.7111 86.7276 12.2908 86.0183 12.0018C85.3352 11.7128 84.5733 11.5683 83.7325 11.5683Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M79.853 29.7285L79.8511 29.7277C78.6632 29.2147 77.6359 28.4849 76.7712 27.5392L76.7662 27.5337C75.9295 26.5621 75.2842 25.4175 74.8282 24.1032L74.8277 24.1018C74.3711 22.7588 74.1445 21.2731 74.1445 19.6474C74.1445 17.996 74.3709 16.4971 74.8277 15.1537L74.8291 15.1495C75.311 13.8109 75.9694 12.6664 76.8068 11.7205C77.6449 10.7477 78.6465 10.0032 79.8098 9.4892L79.8117 9.48835C81.0019 8.97439 82.3101 8.71924 83.7328 8.71924C85.1294 8.71924 86.3994 8.97445 87.5386 9.48963C88.6989 10.0025 89.6868 10.7191 90.4992 11.6394C91.3112 12.5331 91.9314 13.6002 92.3615 14.8368C92.7921 16.0747 93.0058 17.4294 93.0058 18.8987V20.6446H77.9516V21.342C77.9516 22.2081 78.0916 23.0055 78.3689 23.7367C78.6466 24.4688 79.0361 25.0961 79.5361 25.6218C80.0619 26.147 80.6887 26.5614 81.4192 26.8643C82.1755 27.1409 83.0115 27.2809 83.9299 27.2809C85.2566 27.2809 86.3913 26.9752 87.3441 26.3735C88.3013 25.7689 89.0322 24.9383 89.5382 23.8757L89.6625 23.6146L92.3985 25.4696L92.3147 25.6593C91.688 27.076 90.6406 28.2419 89.1854 29.1581L89.1843 29.1588C87.7442 30.0555 85.9885 30.4968 83.9299 30.4968C82.4302 30.4968 81.07 30.2423 79.853 29.7285ZM81.3289 27.0957C80.567 26.7805 79.9101 26.347 79.3584 25.7952C78.833 25.2435 78.4257 24.5867 78.1367 23.8248C77.8477 23.0629 77.7032 22.2353 77.7032 21.342V20.3962H92.7575V18.8987C92.7575 17.4537 92.5473 16.1269 92.127 14.9184C91.7066 13.7098 91.1023 12.672 90.3141 11.805C89.526 10.9118 88.567 10.2155 87.4373 9.71635C86.3338 9.21717 85.099 8.96758 83.7328 8.96758C82.3404 8.96758 81.0661 9.21717 79.9101 9.71635C78.7804 10.2155 77.8083 10.938 76.9939 11.8839C76.1794 12.8034 75.5357 13.92 75.0628 15.2336C74.6162 16.5473 74.3929 18.0185 74.3929 19.6474C74.3929 21.2501 74.6162 22.7082 75.0628 24.0218C75.5095 25.3092 76.14 26.4258 76.9545 27.3716C77.7952 28.2912 78.7936 29.0005 79.9496 29.4997C81.1318 29.9989 82.4586 30.2485 83.9299 30.2485C85.9529 30.2485 87.6606 29.815 89.053 28.948C90.4718 28.0547 91.4833 26.925 92.0875 25.5588L89.7624 23.9824C89.7263 24.0583 89.689 24.1331 89.6507 24.2067C89.1311 25.204 88.4064 25.9962 87.4767 26.5834C86.4783 27.214 85.2961 27.5292 83.9299 27.5292C82.9841 27.5292 82.1171 27.3847 81.3289 27.0957ZM88.7009 15.2383C88.4489 14.5327 88.0854 13.9327 87.6119 13.4342L87.6031 13.425C87.1574 12.9049 86.5996 12.507 85.9249 12.2321L85.9218 12.2308C85.2731 11.9564 84.5447 11.8169 83.7328 11.8169C82.8966 11.8169 82.1289 11.9688 81.4267 12.2698C80.7203 12.5725 80.1039 12.9877 79.5756 13.5155C79.0743 14.0423 78.6711 14.6713 78.3671 15.4053C78.0914 16.108 77.9516 16.8904 77.9516 17.7558V17.7833H89.12V17.5982C89.12 16.732 88.9799 15.9488 88.7037 15.2456L88.7009 15.2383ZM89.3683 18.0317H77.7032V17.7558C77.7032 16.8625 77.8477 16.0481 78.1367 15.3124C78.452 14.5505 78.8724 13.8937 79.3978 13.342C79.9496 12.7903 80.5932 12.3568 81.3289 12.0415C82.0645 11.7262 82.8658 11.5686 83.7328 11.5686C84.5736 11.5686 85.3355 11.7131 86.0186 12.0021C86.7279 12.2911 87.319 12.7114 87.792 13.2632C88.2911 13.7886 88.6721 14.4192 88.9348 15.1548C89.2238 15.8904 89.3683 16.7049 89.3683 17.5982V18.0317Z'
        fill='currentColor'
      />
      <path
        d='M66.1341 4.8988C65.2146 4.8988 64.5709 4.71489 64.2031 4.34708C63.8352 3.95299 63.6513 3.46694 63.6513 2.88894V2.2584C63.6513 1.6804 63.8352 1.20749 64.2031 0.83967C64.5709 0.44558 65.2146 0.248535 66.1341 0.248535C67.0536 0.248535 67.6973 0.44558 68.0651 0.83967C68.433 1.20749 68.6169 1.6804 68.6169 2.2584V2.88894C68.6169 3.46694 68.433 3.95299 68.0651 4.34708C67.6973 4.71489 67.0536 4.8988 66.1341 4.8988ZM57.2277 27.0467H64.5577V12.5932H56.293V9.44166H67.7105V27.0467H74.5676V29.7265H57.2277V27.0467Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M64.0199 4.51634C63.6058 4.07275 63.4013 3.52468 63.4013 2.88875V2.25821C63.4013 1.62387 63.6051 1.0862 64.0228 0.666864C64.4621 0.198857 65.1921 0 66.1324 0C67.0728 0 67.8028 0.198855 68.2421 0.666856C68.6598 1.0862 68.8636 1.62387 68.8636 2.25821V2.88875C68.8636 3.52468 68.6591 4.07275 68.245 4.51634L68.2392 4.5226C67.7999 4.96192 67.0713 5.14696 66.1324 5.14696C65.1936 5.14696 64.4651 4.96181 64.0258 4.52249L64.0199 4.51634ZM68.0635 0.83948C67.6957 0.44539 67.052 0.248345 66.1324 0.248345C65.2129 0.248345 64.5692 0.44539 64.2014 0.83948C63.8336 1.2073 63.6497 1.68021 63.6497 2.25821V2.88875C63.6497 3.46675 63.8336 3.9528 64.2014 4.34689C64.5692 4.7147 65.2129 4.89861 66.1324 4.89861C67.052 4.89861 67.6957 4.7147 68.0635 4.34689C68.4313 3.9528 68.6152 3.46675 68.6152 2.88875V2.25821C68.6152 1.68021 68.4313 1.2073 68.0635 0.83948ZM56.9777 26.7982H64.3077V12.8413H56.043V9.19312H67.9572V26.7982H74.8143V29.9747H56.9777V26.7982ZM67.7088 27.0465V9.44147H56.2913V12.593H64.5561V27.0465H57.226V29.7263H74.566V27.0465H67.7088Z'
        fill='currentColor'
      />
      <path
        d='M37.3809 27.0957H43.3316V12.1202H37.3809V9.44043H46.4843V14.5636H46.6814C47.1018 12.961 47.8899 11.713 49.0459 10.8197C50.2282 9.9002 51.7258 9.44043 53.5386 9.44043H56.376V12.5932H52.5533C50.7405 12.5932 49.2693 13.1186 48.1395 14.1695C47.0361 15.2204 46.4843 16.5997 46.4843 18.3075V27.0957H54.3662V29.7755H37.3809V27.0957Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M37.1328 26.8472H43.0836V12.3684H37.1328V9.19189H46.733V13.5897C47.2013 12.3673 47.9206 11.3756 48.8941 10.6233C50.1285 9.66332 51.6829 9.19189 53.5389 9.19189H56.6247V12.8413H52.5536C50.7925 12.8413 49.3858 13.35 48.3101 14.3502C47.2627 15.3482 46.733 16.659 46.733 18.3073V26.8472H54.6148V30.0237H37.1328V26.8472ZM46.4846 27.0955V18.3073C46.4846 16.5996 47.0364 15.2202 48.1398 14.1693C49.2696 13.1184 50.7408 12.593 52.5536 12.593H56.3763V9.44024H53.5389C51.726 9.44024 50.2285 9.90001 49.0462 10.8196C47.9357 11.6777 47.1646 12.8632 46.733 14.376C46.7153 14.4379 46.6982 14.5004 46.6817 14.5634H46.4846V9.44024H37.3812V12.1201H43.3319V27.0955H37.3812V29.7753H54.3665V27.0955H46.4846Z'
        fill='currentColor'
      />
      <path
        d='M32.2726 26.4651H32.1149C31.9047 26.9643 31.642 27.4504 31.3267 27.9233C31.0115 28.3699 30.6174 28.764 30.1445 29.1055C29.6978 29.4471 29.1592 29.723 28.5287 29.9331C27.8982 30.1433 27.1625 30.2484 26.3218 30.2484C24.1937 30.2484 22.486 29.5785 21.1986 28.2386C19.9113 26.8724 19.2676 24.9545 19.2676 22.4848V9.44043H22.4203V21.9331C22.4203 23.7985 22.8275 25.1909 23.642 26.1105C24.4564 27.0037 25.6518 27.4504 27.2282 27.4504C27.8588 27.4504 28.4762 27.3716 29.0804 27.2139C29.6847 27.0563 30.2233 26.8198 30.6962 26.5046C31.1691 26.1893 31.5501 25.7952 31.8391 25.3223C32.1281 24.8231 32.2726 24.232 32.2726 23.5489V9.44043H35.4253V29.7755H32.2726V26.4651Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M31.5299 28.0663C31.1984 28.5359 30.7854 28.9486 30.2929 29.3047C29.8215 29.6647 29.2583 29.9516 28.6075 30.1685C27.946 30.3891 27.1828 30.4966 26.3221 30.4966C24.1371 30.4966 22.361 29.8063 21.0198 28.4104L21.0182 28.4087C19.6751 26.9834 19.0195 24.997 19.0195 22.4846V9.19189H22.6689V21.9329C22.6689 23.7671 23.0699 25.0886 23.827 25.9443C24.5812 26.7705 25.7004 27.2018 27.2285 27.2018C27.8381 27.2018 28.4344 27.1257 29.018 26.9734C29.5982 26.8221 30.111 26.5962 30.5587 26.2977C31.0016 26.0025 31.3564 25.6353 31.6259 25.1951C31.8883 24.7407 32.0245 24.195 32.0245 23.5487V9.19189H35.6739V30.0237H32.0245V27.2367C31.8775 27.5159 31.7138 27.7906 31.5337 28.0608L31.5299 28.0663ZM32.0245 26.6724C31.831 27.099 31.5985 27.5159 31.327 27.9231C31.0118 28.3697 30.6177 28.7638 30.1448 29.1054C29.6981 29.4469 29.1595 29.7228 28.529 29.9329C27.8985 30.1431 27.1628 30.2482 26.3221 30.2482C24.194 30.2482 22.4863 29.5783 21.1989 28.2384C19.9116 26.8722 19.2679 24.9543 19.2679 22.4846V9.44024H22.4206V21.9329C22.4206 23.7983 22.8278 25.1907 23.6423 26.1103C24.4567 27.0035 25.6521 27.4502 27.2285 27.4502C27.859 27.4502 28.4765 27.3714 29.0807 27.2137C29.685 27.0561 30.2236 26.8196 30.6965 26.5044C31.1694 26.1891 31.5504 25.795 31.8394 25.3221C32.1284 24.8229 32.2729 24.2318 32.2729 23.5487V9.44024H35.4256V29.7753H32.2729V26.465H32.1152C32.086 26.5343 32.0558 26.6035 32.0245 26.6724Z'
        fill='currentColor'
      />
      <path
        d='M9.46976 30.2482C7.99849 30.2482 6.68486 29.9986 5.52886 29.4994C4.39913 28.9739 3.44018 28.2514 2.652 27.3319C1.86382 26.4124 1.25955 25.2958 0.839182 23.9821C0.445092 22.6685 0.248047 21.2104 0.248047 19.6077C0.248047 18.0051 0.458228 16.547 0.878591 15.2333C1.29895 13.9197 1.90323 12.8031 2.69141 11.8836C3.47959 10.9377 4.43854 10.2152 5.56827 9.71606C6.698 9.21688 7.98536 8.96729 9.43036 8.96729C11.4008 8.96729 13.0034 9.40078 14.2383 10.2678C15.4731 11.1348 16.3795 12.2645 16.9575 13.657L14.4353 14.9969C14.0675 13.946 13.4501 13.1315 12.5831 12.5535C11.7424 11.9755 10.6914 11.6865 9.43036 11.6865C8.51081 11.6865 7.68322 11.8441 6.94759 12.1594C6.23822 12.4484 5.63395 12.8688 5.13477 13.4205C4.63559 13.9722 4.25463 14.6291 3.99191 15.391C3.75545 16.1529 3.63723 16.9805 3.63723 17.8737V21.3417C3.63723 22.235 3.75545 23.0626 3.99191 23.8245C4.25463 24.5864 4.63559 25.2432 5.13477 25.795C5.63395 26.3467 6.25136 26.7802 6.987 27.0954C7.72263 27.3844 8.56336 27.5289 9.50917 27.5289C10.8754 27.5289 12.0051 27.2137 12.8984 26.5831C13.7916 25.9526 14.501 25.0856 15.0264 23.9821L17.2728 25.5191C16.6685 26.8853 15.7227 28.015 14.4353 28.9083C13.1742 29.8015 11.519 30.2482 9.46976 30.2482Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.42442 29.7249C4.26349 29.1849 3.27568 28.4411 2.46374 27.4938C1.6512 26.5459 1.03202 25.399 0.602951 24.0581L0.60157 24.0538C0.19948 22.7135 0 21.2309 0 19.608C0 17.9838 0.213018 16.4996 0.64236 15.1579C1.07123 13.8177 1.69004 12.6712 2.50202 11.7235C3.31456 10.7489 4.30413 10.0036 5.4682 9.4892C6.63446 8.97387 7.9569 8.71924 9.43065 8.71924C11.4367 8.71924 13.0935 9.16068 14.3813 10.0648C15.6546 10.9589 16.5911 12.1261 17.1872 13.5621L17.2737 13.7706L14.2967 15.3522L14.2012 15.0792C13.8499 14.0755 13.2646 13.3064 12.4456 12.7604L12.4427 12.7585C11.6522 12.215 10.6535 11.9352 9.43065 11.9352C8.53977 11.9352 7.74617 12.0878 7.04571 12.388L7.0416 12.3897C6.36571 12.6651 5.79264 13.0642 5.31922 13.5874C4.84513 14.1114 4.48092 14.7372 4.22824 15.4686C4.00077 16.203 3.88587 17.0042 3.88587 17.874V21.342C3.88587 22.2118 4.00077 23.0131 4.22825 23.7475C4.48092 24.4788 4.84513 25.1046 5.31922 25.6286C5.79185 26.151 6.3779 26.5639 7.08164 26.866C7.78245 27.1407 8.59031 27.2809 9.50947 27.2809C10.8373 27.2809 11.9135 26.9749 12.7554 26.3805C13.61 25.7773 14.2932 24.9453 14.8025 23.8757L14.9274 23.6135L17.5837 25.431L17.5002 25.6198C16.8767 27.0295 15.9006 28.194 14.5782 29.1119C14.5779 29.1121 14.5775 29.1124 14.5772 29.1126L14.4356 28.9086L14.5792 29.1112C14.5788 29.1114 14.5785 29.1117 14.5782 29.1119C13.2635 30.0428 11.5537 30.4968 9.47006 30.4968C7.97057 30.4968 6.62258 30.2424 5.43071 29.7277L5.42442 29.7249ZM6.98729 27.0957C6.25166 26.7805 5.63425 26.347 5.13507 25.7952C4.63589 25.2435 4.25493 24.5867 3.9922 23.8248C3.75575 23.0629 3.63752 22.2353 3.63752 21.342V17.874C3.63752 16.9808 3.75575 16.1532 3.9922 15.3913C4.25493 14.6293 4.63589 13.9725 5.13507 13.4208C5.63425 12.8691 6.23852 12.4487 6.94788 12.1597C7.68352 11.8444 8.51111 11.6868 9.43065 11.6868C10.6917 11.6868 11.7427 11.9758 12.5834 12.5538C13.3848 13.0881 13.9729 13.8243 14.3478 14.7626C14.3785 14.8394 14.4078 14.9176 14.4356 14.9972L16.9578 13.6573C16.3798 12.2648 15.4734 11.1351 14.2386 10.2681C13.0037 9.40108 11.4011 8.96758 9.43065 8.96758C7.98566 8.96758 6.69829 9.21717 5.56857 9.71635C4.43884 10.2155 3.47989 10.938 2.69171 11.8839C1.90353 12.8034 1.29925 13.92 0.87889 15.2336C0.458527 16.5473 0.248345 18.0054 0.248345 19.608C0.248345 21.2107 0.44539 22.6688 0.839481 23.9824C1.25984 25.2961 1.86412 26.4127 2.6523 27.3322C3.44048 28.2517 4.39943 28.9742 5.52916 29.4997C6.68516 29.9989 7.99879 30.2485 9.47006 30.2485C11.5193 30.2485 13.1745 29.8019 14.4356 28.9086C15.723 28.0153 16.6688 26.8856 17.2731 25.5194L15.0267 23.9824C14.9905 24.0585 14.9534 24.1334 14.9155 24.2072C14.4026 25.2043 13.7304 25.9963 12.8987 26.5834C12.0054 27.214 10.8757 27.5292 9.50947 27.5292C8.56365 27.5292 7.72293 27.3847 6.98729 27.0957Z'
        fill='currentColor'
      />
    </svg>
  )
}

export const IconEye = () => {
  return (
    <svg viewBox='0 0 24 24' height='16' width='16' xmlns='http://www.w3.org/2000/svg'>
      <defs>
        <linearGradient id='svgGradient' x1='0' y1='0' x2='1' y2='0'>
          <stop offset='0%' stopColor='#AB97FE' />
          <stop offset='10%' stopColor='#fbb0a9cc' />
          <stop offset='90%' stopColor='#AB97FEaa' />
          <stop offset='100%' stopColor='#AB97FEaa' />
        </linearGradient>
        <style>
          {`
        .gradient-path {
          fill: url(#svgGradient);
        }`}
        </style>
      </defs>
      <path
        className='gradient-path'
        d='M12 6.5a9.77 9.77 0 0 1 8.82 5.5c-1.65 3.37-5.02 5.5-8.82 5.5S4.83 15.37 3.18 12A9.77 9.77 0 0 1 12 6.5m0-2C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zm0 5a2.5 2.5 0 0 1 0 5 2.5 2.5 0 0 1 0-5m0-2c-2.48 0-4.5 2.02-4.5 4.5s2.02 4.5 4.5 4.5 4.5-2.02 4.5-4.5-2.02-4.5-4.5-4.5z'
        fill='url(#svgGradient)'
      ></path>
    </svg>
  )
}

export const IconCurieStar: FC<Props> = ({ className }) => {
  return (
    <svg
      className={className}
      width='19'
      height='19'
      viewBox='0 0 19 19'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M14.0281 10.0187L10.2256 11.8665C10.2256 11.8665 8.37779 15.6691 8.37779 15.669C8.28499 15.8765 7.96606 15.8743 7.87154 15.6691L6.02373 11.8665L2.22122 10.0187C2.1256 9.97093 2.06372 9.87249 2.06372 9.76562C2.06372 9.65593 2.1256 9.5575 2.22122 9.51249L6.02373 7.66467C6.02373 7.66467 7.87154 3.86219 7.87154 3.8622C7.96573 3.65047 8.28529 3.6529 8.37779 3.86219L10.2256 7.66467L14.0281 9.51249C14.1265 9.5575 14.1884 9.65593 14.1884 9.76562C14.1884 9.87249 14.1265 9.97093 14.0281 10.0187ZM11.4772 4.68624L13.0915 5.47093L13.8762 7.0853C13.9212 7.18093 14.0197 7.2428 14.1294 7.2428C14.2362 7.2428 14.3347 7.18093 14.3825 7.0853L15.1643 5.47093L16.7787 4.68624C16.8743 4.64124 16.9362 4.5428 16.9362 4.43593C16.9362 4.32624 16.8743 4.22781 16.7787 4.1828L15.1643 3.39812L14.3825 1.78374C14.2892 1.5779 13.9658 1.57668 13.8762 1.78376C13.8762 1.78374 13.0915 3.39812 13.0915 3.39812L11.4772 4.1828C11.2723 4.27099 11.269 4.59706 11.4772 4.68624ZM16.7787 14.3162L15.1644 13.5315L14.3825 11.9172C14.3347 11.8216 14.2362 11.7597 14.1294 11.7597C14.0197 11.7597 13.9212 11.8216 13.8762 11.9172L13.0915 13.5315L11.4772 14.3162C11.3815 14.3612 11.3197 14.4597 11.3197 14.5666C11.3197 14.6762 11.3815 14.7747 11.4772 14.8197L13.0915 15.6044L13.8762 17.2187C13.9659 17.4247 14.2892 17.4257 14.3825 17.2187C14.3825 17.2187 15.1644 15.6044 15.1644 15.6044L16.7787 14.8197C16.9835 14.7315 16.9868 14.4054 16.7787 14.3162Z'
        fill='#947BFF'
      />
    </svg>
  )
}

export const IconCurieStarButton: FC<Props> = ({ className }) => {
  return (
    <svg
      className={className}
      width='15'
      height='16'
      viewBox='0 0 15 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M12.0281 8.51873L8.2256 10.3665C8.2256 10.3665 6.37779 14.1691 6.37779 14.169C6.28499 14.3765 5.96606 14.3743 5.87154 14.1691L4.02373 10.3665L0.221221 8.51873C0.125604 8.47093 0.0637207 8.37249 0.0637207 8.26562C0.0637207 8.15593 0.125604 8.0575 0.221221 8.01249L4.02373 6.16467C4.02373 6.16467 5.87154 2.36219 5.87154 2.3622C5.96573 2.15047 6.28529 2.1529 6.37779 2.36219L8.2256 6.16467L12.0281 8.01249C12.1265 8.0575 12.1884 8.15593 12.1884 8.26562C12.1884 8.37249 12.1265 8.47093 12.0281 8.51873ZM9.47717 3.18624L11.0915 3.97093L11.8762 5.5853C11.9212 5.68093 12.0197 5.7428 12.1294 5.7428C12.2362 5.7428 12.3347 5.68093 12.3825 5.5853L13.1643 3.97093L14.7787 3.18624C14.8743 3.14124 14.9362 3.0428 14.9362 2.93593C14.9362 2.82624 14.8743 2.72781 14.7787 2.6828L13.1643 1.89812L12.3825 0.283745C12.2892 0.0779008 11.9658 0.076683 11.8762 0.283756C11.8762 0.283745 11.0915 1.89812 11.0915 1.89812L9.47716 2.6828C9.27234 2.77099 9.26904 3.09706 9.47717 3.18624ZM14.7787 12.8162L13.1644 12.0315L12.3825 10.4172C12.3347 10.3216 12.2362 10.2597 12.1294 10.2597C12.0197 10.2597 11.9212 10.3216 11.8762 10.4172L11.0915 12.0315L9.47717 12.8162C9.38154 12.8612 9.31965 12.9597 9.31965 13.0666C9.31965 13.1762 9.38154 13.2747 9.47717 13.3197L11.0915 14.1044L11.8762 15.7187C11.9659 15.9247 12.2892 15.9257 12.3825 15.7187C12.3825 15.7187 13.1644 14.1044 13.1644 14.1044L14.7787 13.3197C14.9835 13.2315 14.9868 12.9054 14.7787 12.8162Z'
        fill='url(#paint0_linear_493_42834)'
      />
      <defs>
        <linearGradient
          id='paint0_linear_493_42834'
          x1='0.0637212'
          y1='11.8352'
          x2='13.2644'
          y2='-5.79275'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#F7DEE9' />
          <stop offset='1' stopColor='#C8A7FF' />
        </linearGradient>
      </defs>
    </svg>
  )
}

export const IconStartTrialCampaign: FC<Props> = ({ className }) => {
  return (
    <svg
      className={className}
      width='40'
      height='26'
      viewBox='0 0 40 26'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect width='40' height='26' rx='13' fill='white' />
      <path
        d='M13.8493 13.7146L23.6493 13.7146L19.2597 18.1042L20.2806 19.125L26.4056 13L20.2806 6.875L19.2597 7.89583L23.6493 12.2854L13.8493 12.2854L13.8493 13.7146Z'
        fill='black'
      />
    </svg>
  )
}

export const IconCampaignTimelineSubmited: FC<Props> = ({ className }) => {
  return (
    <svg
      className={className}
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect width='24' height='24' rx='12' fill='#947BFF' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M17.0964 7.39016L9.93638 14.3002L8.03638 12.2702C7.68638 11.9402 7.13638 11.9202 6.73638 12.2002C6.34638 12.4902 6.23638 13.0002 6.47638 13.4102L8.72638 17.0702C8.94638 17.4102 9.32638 17.6202 9.75638 17.6202C10.1664 17.6202 10.5564 17.4102 10.7764 17.0702C11.1364 16.6002 18.0064 8.41016 18.0064 8.41016C18.9064 7.49016 17.8164 6.68016 17.0964 7.38016V7.39016Z'
        fill='white'
      />
    </svg>
  )
}

export const IconCampaignTimelineCompleted: FC<Props> = ({ className }) => {
  return (
    <svg
      className={className}
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect
        x='0.75'
        y='0.75'
        width='22.5'
        height='22.5'
        rx='11.25'
        fill='#FAFAFA'
        stroke='#E9EAEB'
        strokeWidth='1.5'
      />
      <circle cx='12' cy='12' r='4' fill='#D5D7DA' />
    </svg>
  )
}

export const IconCampaignTimelineInProgress: FC<Props> = ({ className }) => {
  return (
    <svg
      className={className}
      xmlns='http://www.w3.org/2000/svg'
      width='28'
      height='28'
      viewBox='-2 -2 28 28'
      fill='none'
    >
      <circle cx='12' cy='12' r='12' stroke='#947BFF' strokeWidth='1.5' fill='white' />
      <circle cx='12' cy='12' r='8' fill='#947BFF' />
      <circle cx='12' cy='12' r='3.5' fill='white' />
    </svg>
  )
}

export const PopoverNavDownIcon: FC<Props> = ({ className }) => {
  return (
    <svg
      className={className}
      width='10'
      height='6'
      viewBox='0 0 10 6'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        id='vector'
        d='M5.00004 4.29293L1.35359 0.646484L0.646484 1.35359L5.00004 5.70714L9.35359 1.35359L8.64648 0.646484L5.00004 4.29293Z'
        fill='#161513'
      />
    </svg>
  )
}

export const ApacheCamelIcon: FC<Props> = ({ className }) => {
  return (
    <svg
      className={className}
      height='24'
      width='24'
      preserveAspectRatio='xMidYMid'
      viewBox='0 0 256 256'
      xmlns='http://www.w3.org/2000/svg'
    >
      <defs>
        <linearGradient id='purpleGradient' x1='0%' y1='0%' x2='100%' y2='0%'>
          <stop offset='0%' stopColor='#AB97FE' />
          <stop offset='50%' stopColor='#D3B6B8' />
          <stop offset='100%' stopColor='#FFD86C' />
        </linearGradient>
      </defs>
      <mask id='d' fill='#fff'>
        <circle cx='128' cy='128.00015' fill='#fff' r='128' />
      </mask>
      <circle cx='127.99429' cy='127.994289' fill='transparent' mask='url(#d)' r='123.110531' />
      <path
        d='m128 256c-70.692448 0-128-57.307552-128-128s57.307552-128 128-128 128 57.307552 128 128-57.307552 128-128 128zm0-9.767953c65.297756 0 118.232047-52.93429 118.232047-118.232047 0-65.2977566-52.934291-118.23204715-118.232047-118.23204715-65.2977567 0-118.23204713 52.93429055-118.23204713 118.23204715 0 65.297757 52.93429043 118.232047 118.23204713 118.232047z'
        fill='url(#purpleGradient)'
        mask='url(#d)'
      />
      <path
        d='m98.0436948 75.5167519c-1.7506821-.0019691-3.5241669.0098457-5.2920593.0614371-2.0551898.0606495-4.8163156.7131825-7.9996247 1.7845317 53.7751992 40.8340223 73.1082012 114.4975193 39.8750522 178.5142083 1.128651.02934 2.248756.123071 3.384555.123071 60.736103 0 111.492614-42.322691 124.609045-99.07129-38.541945-45.177942-90.812723-81.3135996-154.577362-81.4120565z'
        fill='transparent'
        mask='url(#d)'
        opacity='.75'
      />
      <path
        d='m84.7520108 77.3677419c-17.8565405 6.0094166-51.9222405 27.1780471-84.67294989 55.4430601 2.48721867 67.334686 57.02821629 121.312708 124.54800209 123.071148 33.233149-64.016688 13.900935-137.680186-39.8750522-178.5142081z'
        fill='transparent'
        mask='url(#d)'
        opacity='.75'
      />
      <path
        d='m128.747194 54.0045284c-10.984858 5.4953716 0 27.4660679 0 27.4660679-32.973015 27.4837247-25.967206 74.4291207-64.4353959 74.4291207-20.9703429 0-42.2422261-24.076794-64.23273719-38.828034-.28309669 3.47897-.78535974 6.972463-.78535974 10.524414 0 48.095047 26.26287413 89.924363 65.41967773 111.897217 10.9526831-1.379601 22.8386364-4.114448 31.0509907-9.592555 43.1452694-28.764821 53.8570354-83.490961 71.4863274-109.92509 10.978972-16.492 62.434296-15.061018 65.906792-22.0101294 5.501257-10.9907433-10.990547-27.4660679-16.491804-27.4660679h-43.95748c-3.071295 0-7.897083-5.4563306-10.974264-5.4563306h-16.491804s-7.306955-11.0851089-13.794244-11.5259393c-.929903-.0661147-1.830633.0525779-2.700699.4873266z'
        fill='url(#purpleGradient)'
        mask='url(#d)'
      />
    </svg>
  )
}

export const IconLocalRepository: FC<Props> = ({ className }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      className={className}
    >
      <path
        d='M2 2H22V17H13V20H17V22H7V20H11V17H2V2ZM4 4V15H20V4H4ZM6 6H14V13H6V6ZM8 8V11H12V8H8ZM16 13V6H18V13H16Z'
        fill='black'
        fillOpacity='0.85'
      />
    </svg>
  )
}

export const IconPlanCardChecked: FC<Props> = ({ className }) => {
  return (
    <svg
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M9 1.125C4.65117 1.125 1.125 4.65117 1.125 9C1.125 13.3488 4.65117 16.875 9 16.875C13.3488 16.875 16.875 13.3488 16.875 9C16.875 4.65117 13.3488 1.125 9 1.125ZM9 15.5391C5.38945 15.5391 2.46094 12.6105 2.46094 9C2.46094 5.38945 5.38945 2.46094 9 2.46094C12.6105 2.46094 15.5391 5.38945 15.5391 9C15.5391 12.6105 12.6105 15.5391 9 15.5391Z'
        fill='url(#paint0_linear_256_1257)'
      />
      <path
        opacity='0.1'
        d='M9 2.46094C5.38945 2.46094 2.46094 5.38945 2.46094 9C2.46094 12.6105 5.38945 15.5391 9 15.5391C12.6105 15.5391 15.5391 12.6105 15.5391 9C15.5391 5.38945 12.6105 2.46094 9 2.46094ZM12.3996 6.42832L8.69766 11.5611C8.64592 11.6334 8.57771 11.6922 8.49868 11.7328C8.41966 11.7734 8.3321 11.7946 8.24326 11.7946C8.15442 11.7946 8.06686 11.7734 7.98784 11.7328C7.90882 11.6922 7.84061 11.6334 7.78887 11.5611L5.59863 8.52363C5.53184 8.43047 5.59863 8.30039 5.71289 8.30039H6.5373C6.71836 8.30039 6.88711 8.38828 6.99258 8.53418L8.24414 10.2709L11.0074 6.43887C11.1129 6.29121 11.2834 6.20508 11.4627 6.20508H12.2871C12.4014 6.20508 12.4682 6.33516 12.3996 6.42832Z'
        fill='url(#paint1_linear_256_1257)'
      />
      <path
        d='M12.2854 6.20508H11.461C11.2817 6.20508 11.1112 6.29121 11.0057 6.43887L8.24242 10.2709L6.99085 8.53418C6.88538 8.38828 6.71663 8.30039 6.53558 8.30039H5.71116C5.5969 8.30039 5.53011 8.43047 5.5969 8.52363L7.78714 11.5611C7.83889 11.6334 7.90709 11.6922 7.98612 11.7328C8.06514 11.7734 8.1527 11.7946 8.24154 11.7946C8.33038 11.7946 8.41794 11.7734 8.49696 11.7328C8.57599 11.6922 8.64419 11.6334 8.69594 11.5611L12.3979 6.42832C12.4665 6.33516 12.3997 6.20508 12.2854 6.20508Z'
        fill='url(#paint2_linear_256_1257)'
      />
      <defs>
        <linearGradient
          id='paint0_linear_256_1257'
          x1='1.125'
          y1='9'
          x2='16.875'
          y2='9'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#AB97FE' />
          <stop offset='0.82' stopColor='#D3B6B8' />
          <stop offset='0.9898' stopColor='#FFD86C' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_256_1257'
          x1='2.46094'
          y1='9'
          x2='15.5391'
          y2='9'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#AB97FE' />
          <stop offset='0.82' stopColor='#D3B6B8' />
          <stop offset='0.9898' stopColor='#FFD86C' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_256_1257'
          x1='5.57031'
          y1='8.99982'
          x2='12.4256'
          y2='8.99982'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#AB97FE' />
          <stop offset='0.82' stopColor='#D3B6B8' />
          <stop offset='0.9898' stopColor='#FFD86C' />
        </linearGradient>
      </defs>
    </svg>
  )
}

export const IconCheckFilled: FC<Props> = ({ className }) => {
  return (
    <svg
      width='14'
      height='14'
      viewBox='0 0 14 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M7 0C3.13438 0 0 3.13438 0 7C0 10.8656 3.13438 14 7 14C10.8656 14 14 10.8656 14 7C14 3.13438 10.8656 0 7 0ZM10.0234 4.71406L6.73281 9.27656C6.68682 9.34076 6.62619 9.39306 6.55595 9.42914C6.48571 9.46523 6.40787 9.48405 6.32891 9.48405C6.24994 9.48405 6.17211 9.46523 6.10186 9.42914C6.03162 9.39306 5.97099 9.34076 5.925 9.27656L3.97656 6.57656C3.91719 6.49375 3.97656 6.37813 4.07812 6.37813H4.81094C4.97031 6.37813 5.12187 6.45469 5.21562 6.58594L6.32812 8.12969L8.78438 4.72344C8.87813 4.59375 9.02812 4.51562 9.18906 4.51562H9.92188C10.0234 4.51562 10.0828 4.63125 10.0234 4.71406Z'
        fill='#36A764'
      />
    </svg>
  )
}

export const IconCross: FC<Props> = ({ className }) => {
  return (
    <svg
      width='14'
      height='14'
      viewBox='0 0 14 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M7 0C3.13438 0 0 3.13438 0 7C0 10.8656 3.13438 14 7 14C10.8656 14 14 10.8656 14 7C14 3.13438 10.8656 0 7 0ZM7 12.8125C3.79063 12.8125 1.1875 10.2094 1.1875 7C1.1875 3.79063 3.79063 1.1875 7 1.1875C10.2094 1.1875 12.8125 3.79063 12.8125 7C12.8125 10.2094 10.2094 12.8125 7 12.8125Z'
        fill='#EA462D'
      />
      <g transform='translate(4,4)'>
        <path
          d='M5.71562 0.5C5.71562 0.43125 5.65937 0.375 5.59062 0.375L4.55937 0.379687L3.00625 2.23125L1.45469 0.38125L0.421875 0.376563C0.353125 0.376563 0.296875 0.43125 0.296875 0.501563C0.296875 0.53125 0.307812 0.559375 0.326562 0.582812L2.35938 3.00469L0.326562 5.425C0.307682 5.4479 0.297206 5.47657 0.296875 5.50625C0.296875 5.575 0.353125 5.63125 0.421875 5.63125L1.45469 5.62656L3.00625 3.775L4.55781 5.625L5.58906 5.62969C5.65781 5.62969 5.71406 5.575 5.71406 5.50469C5.71406 5.475 5.70312 5.44687 5.68437 5.42344L3.65469 3.00313L5.6875 0.58125C5.70625 0.559375 5.71562 0.529687 5.71562 0.5Z'
          fill='#EA462D'
        />
      </g>
    </svg>
  )
}

export const IconCrossFilled: FC<Props> = ({ className }) => {
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M8 1C4.13438 1 1 4.13438 1 8C1 11.8656 4.13438 15 8 15C11.8656 15 15 11.8656 15 8C15 4.13438 11.8656 1 8 1ZM10.5844 10.6594L9.55313 10.6547L8 8.80313L6.44844 10.6531L5.41563 10.6578C5.34688 10.6578 5.29063 10.6031 5.29063 10.5328C5.29063 10.5031 5.30156 10.475 5.32031 10.4516L7.35313 8.02969L5.32031 5.60938C5.30143 5.58647 5.29096 5.5578 5.29063 5.52812C5.29063 5.45937 5.34688 5.40312 5.41563 5.40312L6.44844 5.40781L8 7.25938L9.55156 5.40938L10.5828 5.40469C10.6516 5.40469 10.7078 5.45937 10.7078 5.52969C10.7078 5.55937 10.6969 5.5875 10.6781 5.61094L8.64844 8.03125L10.6797 10.4531C10.6984 10.4766 10.7094 10.5047 10.7094 10.5344C10.7094 10.6031 10.6531 10.6594 10.5844 10.6594Z'
        fill='#D94B36'
      />
    </svg>
  )
}

export const IconLockTwoTone: FC<Props> = ({ className }) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M19.5 10.875H17.9062V5.625C17.9062 3.96797 16.5633 2.625 14.9062 2.625H9.09375C7.43672 2.625 6.09375 3.96797 6.09375 5.625V10.875H4.5C4.08516 10.875 3.75 11.2102 3.75 11.625V20.625C3.75 21.0398 4.08516 21.375 4.5 21.375H19.5C19.9148 21.375 20.25 21.0398 20.25 20.625V11.625C20.25 11.2102 19.9148 10.875 19.5 10.875ZM7.78125 5.625C7.78125 4.90078 8.36953 4.3125 9.09375 4.3125H14.9062C15.6305 4.3125 16.2188 4.90078 16.2188 5.625V10.875H7.78125V5.625ZM18.5625 19.6875H5.4375V12.5625H18.5625V19.6875Z'
        fill='black'
        fillOpacity='0.45'
      />
      <path
        opacity='0.1'
        d='M5.4375 19.6875H18.5625V12.5625H5.4375V19.6875ZM12 14.3906C12.2381 14.3907 12.4701 14.4663 12.6625 14.6065C12.8549 14.7468 12.9979 14.9445 13.0708 15.1711C13.1438 15.3978 13.1429 15.6417 13.0684 15.8679C12.9939 16.0941 12.8496 16.2908 12.6562 16.4297V17.6719C12.6562 17.775 12.5719 17.8594 12.4688 17.8594H11.5312C11.4281 17.8594 11.3438 17.775 11.3438 17.6719V16.4297C11.1504 16.2908 11.0061 16.0941 10.9316 15.8679C10.8571 15.6417 10.8562 15.3978 10.9292 15.1711C11.0021 14.9445 11.1451 14.7468 11.3375 14.6065C11.5299 14.4663 11.7619 14.3907 12 14.3906Z'
        fill='black'
        fillOpacity='0.45'
      />
      <path
        d='M11.3435 16.43V17.6722C11.3435 17.7753 11.4279 17.8597 11.531 17.8597H12.4685C12.5716 17.8597 12.656 17.7753 12.656 17.6722V16.43C12.8495 16.2911 12.9939 16.0944 13.0684 15.8682C13.143 15.642 13.1438 15.398 13.0709 15.1713C12.9979 14.9446 12.8549 14.7468 12.6624 14.6066C12.4699 14.4663 12.2379 14.3907 11.9997 14.3907C11.7616 14.3907 11.5296 14.4663 11.3371 14.6066C11.1446 14.7468 11.0016 14.9446 10.9286 15.1713C10.8556 15.398 10.8565 15.642 10.9311 15.8682C11.0056 16.0944 11.15 16.2911 11.3435 16.43Z'
        fill='black'
        fillOpacity='0.45'
      />
    </svg>
  )
}

export const NewIconLocalRepository: FC<Props> = ({ className }) => {
  return (
    <svg
      width='32'
      height='33'
      viewBox='0 0 32 33'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <rect y='0.166626' width='32' height='32' rx='16' fill='black' fillOpacity='0.25' />
      <path
        opacity='0.1'
        d='M16.0016 10.2009L9.49769 16.6996H11.1852V22.4248H13.8905V18.4169C13.8905 18.0285 14.2051 17.7138 14.5936 17.7138H17.4061C17.7946 17.7138 18.1092 18.0285 18.1092 18.4169V22.4248H20.8145V16.6996H22.5037L16.4077 10.607L16.0016 10.2009ZM23.6393 17.6347C23.5338 17.7402 23.409 17.8246 23.2737 17.8791C23.409 17.8228 23.5338 17.7402 23.6393 17.6347ZM8.0475 17.0248C8.13539 17.5574 8.59945 17.9652 9.15668 17.9652H9.1725C8.61176 17.9652 8.13715 17.5609 8.0475 17.0248ZM8.03168 16.8402V16.8068V16.8402ZM8.03344 16.7945C8.03519 16.74 8.04222 16.6873 8.05101 16.6345C8.04047 16.6855 8.03519 16.74 8.03344 16.7945Z'
        fill='white'
      />
      <path
        d='M23.717 16.131C23.717 16.1293 23.7152 16.1293 23.7152 16.1275L23.6836 16.0906C23.6818 16.0888 23.68 16.0853 23.6765 16.0836C23.6642 16.0695 23.6502 16.0554 23.6379 16.0414L16.8457 9.25446L16.3904 8.79919C16.2867 8.69614 16.1464 8.63831 16.0002 8.63831C15.8539 8.63831 15.7137 8.69614 15.6099 8.79919L8.36246 16.0431C8.23153 16.1734 8.13491 16.334 8.08121 16.5107L8.07067 16.5476L8.06539 16.567L8.06012 16.5881C8.0566 16.6004 8.05485 16.6127 8.05309 16.625C8.05309 16.6267 8.05309 16.6302 8.05133 16.632C8.04078 16.6847 8.03551 16.7375 8.03375 16.792V16.85C8.03375 16.8588 8.03375 16.8675 8.03551 16.8763C8.03551 16.8851 8.03551 16.8922 8.03727 16.9009C8.03727 16.9097 8.03903 16.9185 8.03903 16.9273C8.03903 16.9379 8.04078 16.9484 8.04254 16.959C8.04254 16.9642 8.0443 16.9695 8.0443 16.9748L8.04957 17.0187V17.0205C8.13922 17.5566 8.61559 17.9609 9.17457 17.9609H9.92164V23.6896H22.0804V17.9644H22.8433C22.9945 17.9644 23.1404 17.9345 23.274 17.8783C23.4076 17.822 23.5324 17.7394 23.6396 17.634C23.7443 17.5296 23.8273 17.4054 23.8837 17.2687C23.9402 17.1321 23.9689 16.9855 23.9683 16.8377C23.9683 16.5793 23.8804 16.3314 23.717 16.131ZM16.9845 22.424H15.0158V18.8381H16.9845V22.424ZM20.8148 16.6988V22.424H18.1095V18.4162C18.1095 18.0277 17.7949 17.7131 17.4064 17.7131H14.5939C14.2054 17.7131 13.8908 18.0277 13.8908 18.4162V22.424H11.1855V16.6988H9.49801L16.0019 10.2002L16.408 10.6062L22.5041 16.6988H20.8148Z'
        fill='white'
      />
    </svg>
  )
}

export const GearIcon: FC<Props> = ({ className }) => {
  return (
    <svg
      width='18'
      height='19'
      viewBox='0 0 18 19'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <g clipPath='url(#clip0_1982_115360)'>
        <path
          d='M8.99991 6.125C8.3324 6.125 7.67988 6.32294 7.12486 6.69379C6.56984 7.06464 6.13726 7.59174 5.88182 8.20845C5.62637 8.82515 5.55954 9.50375 5.68976 10.1584C5.81998 10.8131 6.14142 11.4145 6.61342 11.8865C7.08543 12.3585 7.68679 12.6799 8.34148 12.8102C8.99617 12.9404 9.67477 12.8735 10.2915 12.6181C10.9082 12.3626 11.4353 11.9301 11.8061 11.3751C12.177 10.82 12.3749 10.1675 12.3749 9.5C12.374 8.60518 12.0181 7.74728 11.3854 7.11454C10.7526 6.48181 9.89473 6.12593 8.99991 6.125ZM8.99991 11.75C8.5549 11.75 8.11989 11.618 7.74988 11.3708C7.37987 11.1236 7.09148 10.7722 6.92118 10.361C6.75088 9.94991 6.70633 9.49751 6.79314 9.06105C6.87996 8.62459 7.09425 8.22368 7.40892 7.90901C7.72359 7.59434 8.1245 7.38005 8.56096 7.29323C8.99741 7.20642 9.44981 7.25098 9.86095 7.42127C10.2721 7.59157 10.6235 7.87996 10.8707 8.24997C11.1179 8.61998 11.2499 9.05499 11.2499 9.5C11.2499 10.0967 11.0129 10.669 10.5909 11.091C10.1689 11.5129 9.59665 11.75 8.99991 11.75ZM15.1874 9.65188C15.1902 9.55063 15.1902 9.44938 15.1874 9.34813L16.2365 8.0375C16.2915 7.96869 16.3296 7.88792 16.3476 7.80169C16.3657 7.71547 16.3633 7.62621 16.3405 7.5411C16.1686 6.89464 15.9113 6.27396 15.5755 5.69539C15.5316 5.61968 15.4705 5.55527 15.3973 5.5073C15.3241 5.45933 15.2406 5.42911 15.1537 5.41906L13.4858 5.23344C13.4165 5.16031 13.3462 5.09 13.2749 5.0225L13.078 3.35047C13.0679 3.26343 13.0376 3.17996 12.9895 3.10672C12.9414 3.03347 12.8768 2.97248 12.801 2.9286C12.2222 2.59345 11.6016 2.33645 10.9553 2.1643C10.8701 2.14166 10.7808 2.13934 10.6946 2.15754C10.6084 2.17574 10.5276 2.21394 10.4589 2.26906L9.15179 3.3125C9.05054 3.3125 8.94929 3.3125 8.84803 3.3125L7.53741 2.26555C7.4686 2.21054 7.38782 2.17247 7.3016 2.15439C7.21538 2.13632 7.12612 2.13875 7.041 2.16149C6.39466 2.33377 5.77401 2.59101 5.1953 2.92649C5.11959 2.97045 5.05518 3.03148 5.00721 3.10472C4.95924 3.17796 4.92902 3.26139 4.91897 3.34836L4.73335 5.01899C4.66022 5.08883 4.58991 5.15914 4.52241 5.22992L2.85038 5.42188C2.76334 5.432 2.67987 5.46232 2.60663 5.51042C2.53338 5.55852 2.47239 5.62306 2.4285 5.69891C2.09336 6.2777 1.83636 6.89833 1.66421 7.54461C1.64156 7.62978 1.63925 7.71907 1.65745 7.8053C1.67564 7.89152 1.71385 7.97226 1.76897 8.04102L2.81241 9.34813C2.81241 9.44938 2.81241 9.55063 2.81241 9.65188L1.76546 10.9625C1.71045 11.0313 1.67238 11.1121 1.6543 11.1983C1.63623 11.2845 1.63866 11.3738 1.66139 11.4589C1.83337 12.1054 2.09063 12.726 2.42639 13.3046C2.47036 13.3803 2.53139 13.4447 2.60463 13.4927C2.67787 13.5407 2.7613 13.5709 2.84827 13.5809L4.51608 13.7666C4.58593 13.8397 4.65624 13.91 4.72702 13.9775L4.92179 15.6495C4.93191 15.7366 4.96223 15.82 5.01033 15.8933C5.05843 15.9665 5.12297 16.0275 5.19882 16.0714C5.7776 16.4066 6.39824 16.6636 7.04452 16.8357C7.12969 16.8583 7.21898 16.8607 7.3052 16.8425C7.39143 16.8243 7.47217 16.7861 7.54093 16.7309L8.84803 15.6875C8.94929 15.6903 9.05054 15.6903 9.15179 15.6875L10.4624 16.7366C10.5312 16.7916 10.612 16.8296 10.6982 16.8477C10.7844 16.8658 10.8737 16.8634 10.9588 16.8406C11.6053 16.6686 12.226 16.4114 12.8045 16.0756C12.8802 16.0317 12.9446 15.9706 12.9926 15.8974C13.0406 15.8242 13.0708 15.7407 13.0808 15.6538L13.2665 13.9859C13.3396 13.9166 13.4099 13.8463 13.4774 13.775L15.1494 13.5781C15.2365 13.568 15.3199 13.5377 15.3932 13.4896C15.4664 13.4415 15.5274 13.3769 15.5713 13.3011C15.9065 12.7223 16.1635 12.1017 16.3356 11.4554C16.3583 11.3702 16.3606 11.2809 16.3424 11.1947C16.3242 11.1085 16.286 11.0277 16.2308 10.959L15.1874 9.65188ZM14.0554 9.19485C14.0673 9.39811 14.0673 9.6019 14.0554 9.80516C14.047 9.94432 14.0906 10.0816 14.1777 10.1905L15.1755 11.4371C15.061 11.801 14.9144 12.1539 14.7374 12.4918L13.1483 12.6718C13.01 12.6872 12.8822 12.7533 12.7898 12.8574C12.6544 13.0096 12.5103 13.1538 12.358 13.2891C12.2539 13.3816 12.1878 13.5094 12.1724 13.6477L11.9959 15.2354C11.6581 15.4124 11.3051 15.559 10.9412 15.6734L9.69389 14.6757C9.59408 14.596 9.47009 14.5526 9.34233 14.5527H9.30858C9.10532 14.5646 8.90153 14.5646 8.69827 14.5527C8.55911 14.5443 8.4218 14.5879 8.31296 14.675L7.0628 15.6734C6.69896 15.559 6.34601 15.4124 6.00811 15.2354L5.82811 13.6484C5.81275 13.5101 5.74661 13.3823 5.64249 13.2898C5.49027 13.1545 5.34611 13.0103 5.21077 12.8581C5.11833 12.754 4.99056 12.6879 4.85218 12.6725L3.26452 12.4953C3.08747 12.1575 2.94087 11.8045 2.82647 11.4406L3.82421 10.1933C3.91133 10.0844 3.95493 9.94713 3.94655 9.80797C3.9346 9.60471 3.9346 9.40092 3.94655 9.19766C3.95493 9.0585 3.91133 8.92118 3.82421 8.81235L2.82647 7.56289C2.94096 7.19905 3.08755 6.8461 3.26452 6.5082L4.85147 6.3282C4.98986 6.31284 5.11763 6.2467 5.21007 6.14258C5.34541 5.99036 5.48956 5.84621 5.64178 5.71086C5.74632 5.61836 5.81274 5.4903 5.82811 5.35156L6.0046 3.76461C6.34245 3.58756 6.69541 3.44096 7.05929 3.32656L8.30663 4.3243C8.41547 4.41142 8.55278 4.45502 8.69194 4.44664C8.8952 4.43469 9.09899 4.43469 9.30225 4.44664C9.44141 4.45502 9.57873 4.41142 9.68757 4.3243L10.937 3.32656C11.3009 3.44105 11.6538 3.58764 11.9917 3.76461L12.1717 5.35156C12.1871 5.48995 12.2532 5.61772 12.3573 5.71016C12.5096 5.8455 12.6537 5.98966 12.7891 6.14188C12.8815 6.246 13.0093 6.31214 13.1476 6.3275L14.7353 6.50399C14.9124 6.84184 15.0589 7.1948 15.1733 7.55867L14.1756 8.80602C14.0877 8.91577 14.044 9.0545 14.0533 9.19485H14.0554Z'
          fill='#262626'
        />
      </g>
      <defs>
        <clipPath id='clip0_1982_115360'>
          <rect width='18' height='18' fill='white' transform='translate(0 0.5)' />
        </clipPath>
      </defs>
    </svg>
  )
}

export const XmlUploadIcon: FC<Props> = ({ className }) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <g clipPath='url(#clip0_1982_119163)'>
        <path
          d='M22.5 12.7501V18.7501C22.5 19.1479 22.342 19.5295 22.0607 19.8108C21.7794 20.0921 21.3978 20.2501 21 20.2501H3C2.60218 20.2501 2.22064 20.0921 1.93934 19.8108C1.65804 19.5295 1.5 19.1479 1.5 18.7501V12.7501C1.5 12.3523 1.65804 11.9707 1.93934 11.6894C2.22064 11.4081 2.60218 11.2501 3 11.2501H7.5C7.69891 11.2501 7.88968 11.3291 8.03033 11.4698C8.17098 11.6104 8.25 11.8012 8.25 12.0001C8.25 12.199 8.17098 12.3898 8.03033 12.5304C7.88968 12.6711 7.69891 12.7501 7.5 12.7501H3V18.7501H21V12.7501H16.5C16.3011 12.7501 16.1103 12.6711 15.9697 12.5304C15.829 12.3898 15.75 12.199 15.75 12.0001C15.75 11.8012 15.829 11.6104 15.9697 11.4698C16.1103 11.3291 16.3011 11.2501 16.5 11.2501H21C21.3978 11.2501 21.7794 11.4081 22.0607 11.6894C22.342 11.9707 22.5 12.3523 22.5 12.7501ZM8.03063 7.28073L11.25 4.06041V12.0001C11.25 12.199 11.329 12.3898 11.4697 12.5304C11.6103 12.6711 11.8011 12.7501 12 12.7501C12.1989 12.7501 12.3897 12.6711 12.5303 12.5304C12.671 12.3898 12.75 12.199 12.75 12.0001V4.06041L15.9694 7.28073C16.1101 7.42146 16.301 7.50052 16.5 7.50052C16.699 7.50052 16.8899 7.42146 17.0306 7.28073C17.1714 7.14 17.2504 6.94912 17.2504 6.7501C17.2504 6.55108 17.1714 6.36021 17.0306 6.21948L12.5306 1.71948C12.461 1.64974 12.3783 1.59443 12.2872 1.55668C12.1962 1.51894 12.0986 1.49951 12 1.49951C11.9014 1.49951 11.8038 1.51894 11.7128 1.55668C11.6217 1.59443 11.539 1.64974 11.4694 1.71948L6.96937 6.21948C6.82864 6.36021 6.74958 6.55108 6.74958 6.7501C6.74958 6.94912 6.82864 7.14 6.96938 7.28073C7.11011 7.42146 7.30098 7.50052 7.5 7.50052C7.69902 7.50052 7.88989 7.42146 8.03063 7.28073ZM18.75 15.7501C18.75 15.5276 18.684 15.3101 18.5604 15.1251C18.4368 14.9401 18.2611 14.7959 18.0555 14.7107C17.85 14.6256 17.6238 14.6033 17.4055 14.6467C17.1873 14.6901 16.9868 14.7973 16.8295 14.9546C16.6722 15.1119 16.565 15.3124 16.5216 15.5306C16.4782 15.7489 16.5005 15.9751 16.5856 16.1806C16.6708 16.3862 16.815 16.5619 17 16.6855C17.185 16.8091 17.4025 16.8751 17.625 16.8751C17.9234 16.8751 18.2095 16.7566 18.4205 16.5456C18.6315 16.3346 18.75 16.0485 18.75 15.7501Z'
          fill='url(#paint0_linear_1982_119163)'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_1982_119163'
          x1='1.5'
          y1='10.8748'
          x2='22.5'
          y2='10.8748'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#AB97FE' />
          <stop offset='0.82' stopColor='#D3B6B8' />
          <stop offset='0.9898' stopColor='#FFD86C' />
        </linearGradient>
        <clipPath id='clip0_1982_119163'>
          <rect width='24' height='24' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export const RemoveIcon: FC<Props> = ({ className }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      className={className}
    >
      <path
        d='M6.32812 3.23438H6.1875C6.26484 3.23438 6.32812 3.17109 6.32812 3.09375V3.23438H11.6719V3.09375C11.6719 3.17109 11.7352 3.23438 11.8125 3.23438H11.6719V4.5H12.9375V3.09375C12.9375 2.47324 12.433 1.96875 11.8125 1.96875H6.1875C5.56699 1.96875 5.0625 2.47324 5.0625 3.09375V4.5H6.32812V3.23438ZM15.1875 4.5H2.8125C2.50137 4.5 2.25 4.75137 2.25 5.0625V5.625C2.25 5.70234 2.31328 5.76562 2.39062 5.76562H3.45234L3.88652 14.959C3.91465 15.5584 4.41035 16.0312 5.00977 16.0312H12.9902C13.5914 16.0312 14.0854 15.5602 14.1135 14.959L14.5477 5.76562H15.6094C15.6867 5.76562 15.75 5.70234 15.75 5.625V5.0625C15.75 4.75137 15.4986 4.5 15.1875 4.5ZM12.8549 14.7656H5.14512L4.71973 5.76562H13.2803L12.8549 14.7656Z'
        fill='black'
        fillOpacity='0.45'
      />
    </svg>
  )
}

export const GrayGearIcon: FC<Props> = ({ className }) => {
  return (
    <svg
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M6.9374 16.5L6.6374 14.1C6.4749 14.0375 6.32178 13.9625 6.17803 13.875C6.03428 13.7875 5.89365 13.6938 5.75615 13.5938L3.5249 14.5312L1.4624 10.9688L3.39365 9.50625C3.38115 9.41875 3.3749 9.33438 3.3749 9.25313V8.74688C3.3749 8.66563 3.38115 8.58125 3.39365 8.49375L1.4624 7.03125L3.5249 3.46875L5.75615 4.40625C5.89365 4.30625 6.0374 4.2125 6.1874 4.125C6.3374 4.0375 6.4874 3.9625 6.6374 3.9L6.9374 1.5H11.0624L11.3624 3.9C11.5249 3.9625 11.678 4.0375 11.8218 4.125C11.9655 4.2125 12.1062 4.30625 12.2437 4.40625L14.4749 3.46875L16.5374 7.03125L14.6062 8.49375C14.6187 8.58125 14.6249 8.66563 14.6249 8.74688V9.25313C14.6249 9.33438 14.6124 9.41875 14.5874 9.50625L16.5187 10.9688L14.4562 14.5312L12.2437 13.5938C12.1062 13.6938 11.9624 13.7875 11.8124 13.875C11.6624 13.9625 11.5124 14.0375 11.3624 14.1L11.0624 16.5H6.9374ZM8.2499 15H9.73115L9.99365 13.0125C10.3812 12.9125 10.7405 12.7656 11.0718 12.5719C11.403 12.3781 11.7062 12.1438 11.9812 11.8687L13.8374 12.6375L14.5687 11.3625L12.9562 10.1438C13.0187 9.96875 13.0624 9.78438 13.0874 9.59063C13.1124 9.39688 13.1249 9.2 13.1249 9C13.1249 8.8 13.1124 8.60313 13.0874 8.40938C13.0624 8.21563 13.0187 8.03125 12.9562 7.85625L14.5687 6.6375L13.8374 5.3625L11.9812 6.15C11.7062 5.8625 11.403 5.62188 11.0718 5.42813C10.7405 5.23438 10.3812 5.0875 9.99365 4.9875L9.7499 3H8.26865L8.00615 4.9875C7.61865 5.0875 7.25928 5.23438 6.92803 5.42813C6.59678 5.62188 6.29365 5.85625 6.01865 6.13125L4.1624 5.3625L3.43115 6.6375L5.04365 7.8375C4.98115 8.025 4.9374 8.2125 4.9124 8.4C4.8874 8.5875 4.8749 8.7875 4.8749 9C4.8749 9.2 4.8874 9.39375 4.9124 9.58125C4.9374 9.76875 4.98115 9.95625 5.04365 10.1438L3.43115 11.3625L4.1624 12.6375L6.01865 11.85C6.29365 12.1375 6.59678 12.3781 6.92803 12.5719C7.25928 12.7656 7.61865 12.9125 8.00615 13.0125L8.2499 15ZM9.0374 11.625C9.7624 11.625 10.3812 11.3688 10.8937 10.8563C11.4062 10.3438 11.6624 9.725 11.6624 9C11.6624 8.275 11.4062 7.65625 10.8937 7.14375C10.3812 6.63125 9.7624 6.375 9.0374 6.375C8.2999 6.375 7.67803 6.63125 7.17178 7.14375C6.66553 7.65625 6.4124 8.275 6.4124 9C6.4124 9.725 6.66553 10.3438 7.17178 10.8563C7.67803 11.3688 8.2999 11.625 9.0374 11.625Z'
        fill='black'
        fillOpacity='0.45'
      />
    </svg>
  )
}

export const SecuritySearchIcon: FC<Props> = ({ className }) => {
  return (
    <svg
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M15.2385 2.98652L9.26543 0.950977C9.19336 0.926367 9.09668 0.914062 9 0.914062C8.90332 0.914062 8.80664 0.926367 8.73457 0.950977L2.76152 2.98652C2.61563 3.03574 2.49609 3.20449 2.49609 3.35918V11.8389C2.49609 11.9936 2.59629 12.1975 2.71758 12.2941L8.77676 17.0156C8.83828 17.0631 8.91738 17.0877 8.99824 17.0877C9.0791 17.0877 9.15996 17.0631 9.21973 17.0156L15.2789 12.2941C15.4002 12.1992 15.5004 11.9953 15.5004 11.8389V3.35918C15.5039 3.20449 15.3844 3.0375 15.2385 2.98652V2.98652ZM14.2383 11.5014L9 15.583L3.76172 11.5014V3.98496L9 2.19902L14.2383 3.98496V11.5014Z'
        fill='black'
        fillOpacity='0.45'
      />
      <path
        opacity='0.1'
        d='M8.09863 7.92949C8.09863 8.30292 8.24698 8.66105 8.51103 8.9251C8.77508 9.18916 9.13321 9.3375 9.50664 9.3375C9.88007 9.3375 10.2382 9.18916 10.5023 8.9251C10.7663 8.66105 10.9146 8.30292 10.9146 7.92949C10.9146 7.55607 10.7663 7.19793 10.5023 6.93388C10.2382 6.66983 9.88007 6.52148 9.50664 6.52148C9.13321 6.52148 8.77508 6.66983 8.51103 6.93388C8.24698 7.19793 8.09863 7.55607 8.09863 7.92949V7.92949Z'
        fill='black'
        fillOpacity='0.45'
      />
      <path
        opacity='0.1'
        d='M3.76172 3.98516V11.5016L9 15.5832L14.2383 11.5016V3.98516L9 2.19922L3.76172 3.98516ZM11.2975 6.13848C12.2871 7.12813 12.2871 8.73125 11.2975 9.7209C10.4449 10.5734 9.13535 10.6912 8.15801 10.0742L6.7957 11.4365C6.76927 11.4627 6.73358 11.4774 6.69639 11.4774C6.65919 11.4774 6.6235 11.4627 6.59707 11.4365L5.99941 10.8389C5.97324 10.8124 5.95856 10.7767 5.95856 10.7396C5.95856 10.7024 5.97324 10.6667 5.99941 10.6402L7.36172 9.27793C6.74473 8.29883 6.8625 6.99102 7.71504 6.13848C8.70469 5.14883 10.3078 5.14883 11.2975 6.13848V6.13848Z'
        fill='black'
        fillOpacity='0.45'
      />
      <path
        d='M7.36116 9.27793L5.99886 10.6402C5.97269 10.6667 5.95801 10.7024 5.95801 10.7396C5.95801 10.7767 5.97269 10.8124 5.99886 10.8389L6.59652 11.4365C6.65101 11.491 6.74066 11.491 6.79515 11.4365L8.15745 10.0742C9.1348 10.6912 10.4444 10.5734 11.2969 9.7209C12.2866 8.73125 12.2866 7.12813 11.2969 6.13848C10.3073 5.14883 8.70413 5.14883 7.71448 6.13848C6.86195 6.99102 6.74417 8.29883 7.36116 9.27793V9.27793ZM8.51077 6.93477C8.64153 6.80396 8.79677 6.7002 8.96763 6.62941C9.13849 6.55862 9.32163 6.52218 9.50657 6.52218C9.69152 6.52218 9.87466 6.55862 10.0455 6.62941C10.2164 6.7002 10.3716 6.80396 10.5024 6.93477C10.6332 7.06552 10.7369 7.22076 10.8077 7.39162C10.8785 7.56248 10.915 7.74562 10.915 7.93057C10.915 8.11551 10.8785 8.29865 10.8077 8.46951C10.7369 8.64037 10.6332 8.79561 10.5024 8.92637C9.95218 9.47656 9.06097 9.47656 8.51077 8.92637C7.96058 8.37617 7.96058 7.48496 8.51077 6.93477V6.93477Z'
        fill='black'
        fillOpacity='0.45'
      />
    </svg>
  )
}

export const SideBarLogo: FC<Props> = ({ className }) => {
  return (
    <svg
      width='74'
      height='25'
      viewBox='0 0 74 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M66.3001 24.1999C65.1483 24.1999 64.1095 24.0052 63.184 23.6159C62.279 23.2265 61.4974 22.6732 60.8392 21.9559C60.2015 21.2182 59.7079 20.3473 59.3582 19.3431C59.0086 18.3185 58.8337 17.1811 58.8337 15.9311C58.8337 14.6605 59.0086 13.5129 59.3582 12.4883C59.7285 11.4636 60.2324 10.5927 60.87 9.87543C61.5076 9.13769 62.2687 8.57414 63.1531 8.18478C64.0581 7.79541 65.0557 7.60073 66.1458 7.60073C67.2154 7.60073 68.1821 7.79541 69.046 8.18478C69.9304 8.57414 70.6812 9.1172 71.2982 9.81395C71.9153 10.4902 72.3884 11.2997 72.7174 12.2424C73.0465 13.185 73.2111 14.2199 73.2111 15.347V16.5151H61.4254V17.2528C61.4254 17.9496 61.5385 18.5951 61.7647 19.1894C61.991 19.7837 62.3098 20.296 62.7212 20.7264C63.1531 21.1567 63.6673 21.4949 64.2638 21.7408C64.8809 21.9662 65.5596 22.0789 66.3001 22.0789C67.3696 22.0789 68.2952 21.833 69.0768 21.3412C69.8584 20.8493 70.4549 20.1731 70.8663 19.3124L72.6866 20.5419C72.2135 21.6076 71.4216 22.4888 70.3109 23.1855C69.2208 23.8618 67.8839 24.1999 66.3001 24.1999ZM66.1458 9.62952C65.4671 9.62952 64.8397 9.75247 64.2638 9.99839C63.6879 10.2443 63.184 10.5824 62.752 11.0128C62.3407 11.4431 62.0116 11.9555 61.7647 12.5497C61.5385 13.1235 61.4254 13.7588 61.4254 14.4556V14.6707H70.5578V14.3326C70.5578 13.6359 70.4446 13.0006 70.2184 12.4268C70.0127 11.853 69.7144 11.3612 69.3236 10.9513C68.9534 10.521 68.4906 10.1931 67.9353 9.96765C67.4005 9.74223 66.804 9.62952 66.1458 9.62952Z'
        fill='#262626'
      />
      <path
        d='M52.3685 4.42722C51.6486 4.42722 51.1447 4.28378 50.8567 3.99688C50.5688 3.68948 50.4248 3.31037 50.4248 2.85953V2.3677C50.4248 1.91686 50.5688 1.54799 50.8567 1.26109C51.1447 0.953695 51.6486 0.799999 52.3685 0.799999C53.0884 0.799999 53.5923 0.953695 53.8803 1.26109C54.1683 1.54799 54.3122 1.91686 54.3122 2.3677V2.85953C54.3122 3.31037 54.1683 3.68948 53.8803 3.99688C53.5923 4.28378 53.0884 4.42722 52.3685 4.42722ZM45.3958 21.7027H51.1344V10.4289H44.6641V7.97067H53.6026V21.7027H58.971V23.7929H45.3958V21.7027Z'
        fill='#262626'
      />
      <path
        d='M29.8596 21.7409H34.5184V10.06H29.8596V7.96975H36.9866V11.9658H37.1408C37.4699 10.7158 38.087 9.74238 38.992 9.04562C39.9176 8.32837 41.09 7.96975 42.5092 7.96975H44.7306V10.4289H41.7379C40.3187 10.4289 39.1668 10.8387 38.2824 11.6585C37.4185 12.4782 36.9866 13.554 36.9866 14.8861V21.7409H43.1571V23.8312H29.8596V21.7409Z'
        fill='#262626'
      />
      <path
        d='M25.8596 21.2491H25.7362C25.5716 21.6385 25.366 22.0176 25.1191 22.3864C24.8723 22.7348 24.5638 23.0422 24.1936 23.3086C23.8439 23.575 23.4222 23.7902 22.9286 23.9541C22.435 24.1181 21.859 24.2001 21.2008 24.2001C19.5348 24.2001 18.1979 23.6775 17.19 22.6324C16.1821 21.5667 15.6782 20.0708 15.6782 18.1444V7.96975H18.1464V17.7141C18.1464 19.1691 18.4652 20.2552 19.1029 20.9724C19.7405 21.6692 20.6764 22.0176 21.9105 22.0176C22.4041 22.0176 22.8875 21.9561 23.3605 21.8331C23.8336 21.7102 24.2553 21.5257 24.6255 21.2798C24.9957 21.0339 25.294 20.7265 25.5202 20.3577C25.7465 19.9683 25.8596 19.5072 25.8596 18.9744V7.96975H28.3278V23.8312H25.8596V21.2491Z'
        fill='#262626'
      />
      <path
        d='M8.00785 24.1999C6.85602 24.1999 5.8276 24.0052 4.92259 23.6159C4.03814 23.206 3.2874 22.6424 2.67034 21.9252C2.05329 21.208 1.58022 20.337 1.25112 19.3124C0.942593 18.2877 0.78833 17.1504 0.78833 15.9003C0.78833 14.6503 0.952877 13.5129 1.28197 12.4883C1.61107 11.4636 2.08414 10.5927 2.7012 9.87543C3.31825 9.13769 4.069 8.57414 4.95344 8.18478C5.83788 7.79541 6.84574 7.60073 7.977 7.60073C9.51964 7.60073 10.7743 7.93886 11.741 8.61512C12.7077 9.29139 13.4174 10.1726 13.8699 11.2587L11.8953 12.3038C11.6073 11.4841 11.124 10.8488 10.4452 10.398C9.78703 9.94716 8.96429 9.72174 7.977 9.72174C7.25711 9.72174 6.6092 9.84469 6.03328 10.0906C5.47794 10.316 5.00486 10.6439 4.61406 11.0743C4.22326 11.5046 3.92502 12.0169 3.71933 12.6112C3.53422 13.2055 3.44166 13.851 3.44166 14.5478V17.2528C3.44166 17.9496 3.53422 18.5951 3.71933 19.1894C3.92502 19.7837 4.22326 20.296 4.61406 20.7264C5.00486 21.1567 5.48822 21.4949 6.06414 21.7408C6.64005 21.9662 7.29824 22.0789 8.03871 22.0789C9.10827 22.0789 9.99271 21.833 10.692 21.3412C11.3914 20.8493 11.9467 20.1731 12.3581 19.3124L14.1167 20.5112C13.6436 21.5768 12.9031 22.458 11.8953 23.1548C10.908 23.8515 9.61219 24.1999 8.00785 24.1999Z'
        fill='#262626'
      />
    </svg>
  )
}

export const BlackPlus: FC<Props> = ({ className }) => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M7.53125 2.37498H8.46875C8.55208 2.37498 8.59375 2.41665 8.59375 2.49998V13.5C8.59375 13.5833 8.55208 13.625 8.46875 13.625H7.53125C7.44792 13.625 7.40625 13.5833 7.40625 13.5V2.49998C7.40625 2.41665 7.44792 2.37498 7.53125 2.37498Z'
        fill='#2E1F36'
      />
      <path
        d='M2.75 7.40623H13.25C13.3333 7.40623 13.375 7.4479 13.375 7.53123V8.46873C13.375 8.55207 13.3333 8.59373 13.25 8.59373H2.75C2.66667 8.59373 2.625 8.55207 2.625 8.46873V7.53123C2.625 7.4479 2.66667 7.40623 2.75 7.40623Z'
        fill='#2E1F36'
      />
    </svg>
  )
}

export const SearchInputIcon: FC<Props> = ({ className }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      className={className}
    >
      <path
        d='M14.2125 13.3516L10.1547 9.29375C10.7844 8.47969 11.125 7.48438 11.125 6.4375C11.125 5.18438 10.6359 4.00937 9.75156 3.12344C8.86719 2.2375 7.68906 1.75 6.4375 1.75C5.18594 1.75 4.00781 2.23906 3.12344 3.12344C2.2375 4.00781 1.75 5.18438 1.75 6.4375C1.75 7.68906 2.23906 8.86719 3.12344 9.75156C4.00781 10.6375 5.18438 11.125 6.4375 11.125C7.48438 11.125 8.47813 10.7844 9.29219 10.1562L13.35 14.2125C13.3619 14.2244 13.376 14.2338 13.3916 14.2403C13.4071 14.2467 13.4238 14.2501 13.4406 14.2501C13.4575 14.2501 13.4741 14.2467 13.4897 14.2403C13.5052 14.2338 13.5194 14.2244 13.5312 14.2125L14.2125 13.5328C14.2244 13.5209 14.2338 13.5068 14.2403 13.4912C14.2467 13.4757 14.2501 13.459 14.2501 13.4422C14.2501 13.4254 14.2467 13.4087 14.2403 13.3931C14.2338 13.3776 14.2244 13.3635 14.2125 13.3516ZM8.9125 8.9125C8.25 9.57344 7.37187 9.9375 6.4375 9.9375C5.50312 9.9375 4.625 9.57344 3.9625 8.9125C3.30156 8.25 2.9375 7.37187 2.9375 6.4375C2.9375 5.50312 3.30156 4.62344 3.9625 3.9625C4.625 3.30156 5.50312 2.9375 6.4375 2.9375C7.37187 2.9375 8.25156 3.3 8.9125 3.9625C9.57344 4.625 9.9375 5.50312 9.9375 6.4375C9.9375 7.37187 9.57344 8.25156 8.9125 8.9125Z'
        fill='black'
        fillOpacity='0.45'
      />
    </svg>
  )
}

export const EditGrayIcon: FC<Props> = ({ className }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 20 20'
      fill='none'
      className={className}
    >
      <path
        d='M14.6466 1.67358L18.339 5.36273L5.35685 18.3333H1.66516V14.6435L14.6466 1.67358ZM12.8933 5.78126L14.2277 7.11443L15.9809 5.36273L14.6466 4.02956L12.8933 5.78126ZM13.0486 8.29242L11.7143 6.95925L3.33183 15.3342V16.6667H4.66693L13.0486 8.29242Z'
        fill='black'
        fillOpacity='0.45'
      />
    </svg>
  )
}

export const SelectComponentDownCaretIcon: FC<Props> = ({ className }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      className={className}
    >
      <g clipPath='url(#clip0_314_1701)'>
        <path
          d='M16.6922 7.94217L10.4422 14.1922C10.3841 14.2503 10.3152 14.2964 10.2393 14.3278C10.1634 14.3593 10.0821 14.3755 9.99998 14.3755C9.91785 14.3755 9.83652 14.3593 9.76064 14.3278C9.68477 14.2964 9.61584 14.2503 9.55779 14.1922L3.30779 7.94217C3.19052 7.82489 3.12463 7.66583 3.12463 7.49998C3.12463 7.33413 3.19052 7.17507 3.30779 7.05779C3.42507 6.94052 3.58413 6.87463 3.74998 6.87463C3.91583 6.87463 4.07489 6.94052 4.19217 7.05779L9.99998 12.8664L15.8078 7.05779C15.8659 6.99972 15.9348 6.95366 16.0107 6.92224C16.0865 6.89081 16.1679 6.87463 16.25 6.87463C16.3321 6.87463 16.4134 6.89081 16.4893 6.92224C16.5652 6.95366 16.6341 6.99972 16.6922 7.05779C16.7502 7.11586 16.7963 7.1848 16.8277 7.26067C16.8592 7.33654 16.8753 7.41786 16.8753 7.49998C16.8753 7.5821 16.8592 7.66342 16.8277 7.73929C16.7963 7.81516 16.7502 7.8841 16.6922 7.94217Z'
          fill='black'
          fillOpacity='0.88'
        />
      </g>
      <defs>
        <clipPath id='clip0_314_1701'>
          <rect width='20' height='20' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export const SelectComponentDownDisabledCaretIcon: FC<Props> = ({ className }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      className={className}
    >
      <g clipPath='url(#clip0_279_9534)'>
        <path
          d='M16.6922 7.94217L10.4422 14.1922C10.3841 14.2503 10.3152 14.2964 10.2393 14.3278C10.1634 14.3593 10.0821 14.3755 9.99998 14.3755C9.91785 14.3755 9.83652 14.3593 9.76064 14.3278C9.68477 14.2964 9.61584 14.2503 9.55779 14.1922L3.30779 7.94217C3.19052 7.82489 3.12463 7.66583 3.12463 7.49998C3.12463 7.33413 3.19052 7.17507 3.30779 7.05779C3.42507 6.94052 3.58413 6.87463 3.74998 6.87463C3.91583 6.87463 4.07489 6.94052 4.19217 7.05779L9.99998 12.8664L15.8078 7.05779C15.8659 6.99972 15.9348 6.95366 16.0107 6.92224C16.0865 6.89081 16.1679 6.87463 16.25 6.87463C16.3321 6.87463 16.4134 6.89081 16.4893 6.92224C16.5652 6.95366 16.6341 6.99972 16.6922 7.05779C16.7502 7.11586 16.7963 7.1848 16.8277 7.26067C16.8592 7.33654 16.8753 7.41786 16.8753 7.49998C16.8753 7.5821 16.8592 7.66342 16.8277 7.73929C16.7963 7.81516 16.7502 7.8841 16.6922 7.94217Z'
          fill='#1D1B20'
          fillOpacity='0.12'
        />
      </g>
      <defs>
        <clipPath id='clip0_279_9534'>
          <rect width='20' height='20' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export const SelectComponentRightCaretIcon: FC<Props> = ({ className }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      className={className}
    >
      <g clipPath='url(#clip0_314_1981)'>
        <path
          d='M14.1922 10.4422L7.94217 16.6922C7.8841 16.7502 7.81516 16.7963 7.73929 16.8277C7.66342 16.8592 7.5821 16.8753 7.49998 16.8753C7.41786 16.8753 7.33654 16.8592 7.26067 16.8277C7.1848 16.7963 7.11586 16.7502 7.05779 16.6922C6.99972 16.6341 6.95366 16.5652 6.92224 16.4893C6.89081 16.4134 6.87463 16.3321 6.87463 16.25C6.87463 16.1679 6.89081 16.0865 6.92224 16.0107C6.95366 15.9348 6.99972 15.8659 7.05779 15.8078L12.8664 9.99998L7.05779 4.19217C6.94052 4.07489 6.87463 3.91583 6.87463 3.74998C6.87463 3.58413 6.94052 3.42507 7.05779 3.30779C7.17507 3.19052 7.33413 3.12463 7.49998 3.12463C7.66583 3.12463 7.82489 3.19052 7.94217 3.30779L14.1922 9.55779C14.2503 9.61584 14.2964 9.68477 14.3278 9.76064C14.3593 9.83652 14.3755 9.91785 14.3755 9.99998C14.3755 10.0821 14.3593 10.1634 14.3278 10.2393C14.2964 10.3152 14.2503 10.3841 14.1922 10.4422Z'
          fill='black'
          fillOpacity='0.88'
        />
      </g>
      <defs>
        <clipPath id='clip0_314_1981'>
          <rect width='20' height='20' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export const SelectCheckIcon: FC<Props> = ({ className }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      className={className}
    >
      <path
        d='M17.8121 3.71094H16.4468C16.2554 3.71094 16.0738 3.79883 15.9566 3.94922L7.90388 14.1504L4.04255 9.25781C3.98414 9.18365 3.90969 9.12368 3.82478 9.08241C3.73987 9.04114 3.64672 9.01965 3.55232 9.01953H2.18708C2.05622 9.01953 1.98396 9.16992 2.06404 9.27148L7.41365 16.0488C7.66365 16.3652 8.14411 16.3652 8.39607 16.0488L17.9351 3.96094C18.0152 3.86133 17.9429 3.71094 17.8121 3.71094Z'
        fill='#65558F'
      />
    </svg>
  )
}

export const ModalPurpleIcon: FC<Props> = ({ className }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      className={className}
    >
      <path
        d='M12 1.5C6.20156 1.5 1.5 6.20156 1.5 12C1.5 17.7984 6.20156 22.5 12 22.5C17.7984 22.5 22.5 17.7984 22.5 12C22.5 6.20156 17.7984 1.5 12 1.5ZM12.75 17.0625C12.75 17.1656 12.6656 17.25 12.5625 17.25H11.4375C11.3344 17.25 11.25 17.1656 11.25 17.0625V10.6875C11.25 10.5844 11.3344 10.5 11.4375 10.5H12.5625C12.6656 10.5 12.75 10.5844 12.75 10.6875V17.0625ZM12 9C11.7056 8.99399 11.4253 8.87282 11.2192 8.6625C11.0132 8.45218 10.8977 8.16945 10.8977 7.875C10.8977 7.58055 11.0132 7.29782 11.2192 7.0875C11.4253 6.87718 11.7056 6.75601 12 6.75C12.2944 6.75601 12.5747 6.87718 12.7808 7.0875C12.9868 7.29782 13.1023 7.58055 13.1023 7.875C13.1023 8.16945 12.9868 8.45218 12.7808 8.6625C12.5747 8.87282 12.2944 8.99399 12 9Z'
        fill='#9D7EE6'
      />
    </svg>
  )
}

export const ModalGreenIcon: FC<Props> = ({ className }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      className={className}
    >
      <path
        d='M12 1.5C6.20156 1.5 1.5 6.20156 1.5 12C1.5 17.7984 6.20156 22.5 12 22.5C17.7984 22.5 22.5 17.7984 22.5 12C22.5 6.20156 17.7984 1.5 12 1.5ZM16.5352 8.57109L11.5992 15.4148C11.5302 15.5111 11.4393 15.5896 11.3339 15.6437C11.2286 15.6978 11.1118 15.7261 10.9934 15.7261C10.8749 15.7261 10.7582 15.6978 10.6528 15.6437C10.5474 15.5896 10.4565 15.5111 10.3875 15.4148L7.46484 11.3648C7.37578 11.2406 7.46484 11.0672 7.61719 11.0672H8.71641C8.95547 11.0672 9.18281 11.182 9.32344 11.3789L10.9922 13.6945L14.6766 8.58516C14.8172 8.39062 15.0422 8.27344 15.2836 8.27344H16.3828C16.5352 8.27344 16.6242 8.44688 16.5352 8.57109Z'
        fill='#36A764'
      />
    </svg>
  )
}

export const ModalRedIcon: FC<Props> = ({ className }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      className={className}
    >
      <path
        d='M12 1.5C6.20156 1.5 1.5 6.20156 1.5 12C1.5 17.7984 6.20156 22.5 12 22.5C17.7984 22.5 22.5 17.7984 22.5 12C22.5 6.20156 17.7984 1.5 12 1.5ZM12.75 17.0625C12.75 17.1656 12.6656 17.25 12.5625 17.25H11.4375C11.3344 17.25 11.25 17.1656 11.25 17.0625V10.6875C11.25 10.5844 11.3344 10.5 11.4375 10.5H12.5625C12.6656 10.5 12.75 10.5844 12.75 10.6875V17.0625ZM12 9C11.7056 8.99399 11.4253 8.87282 11.2192 8.6625C11.0132 8.45218 10.8977 8.16945 10.8977 7.875C10.8977 7.58055 11.0132 7.29782 11.2192 7.0875C11.4253 6.87718 11.7056 6.75601 12 6.75C12.2944 6.75601 12.5747 6.87718 12.7808 7.0875C12.9868 7.29782 13.1023 7.58055 13.1023 7.875C13.1023 8.16945 12.9868 8.45218 12.7808 8.6625C12.5747 8.87282 12.2944 8.99399 12 9Z'
        fill='#D94B36'
      />
    </svg>
  )
}

export const CloseCircleFilledIcon: FC<Props> = ({ className }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      className={className}
    >
      <path
        d='M8 1C4.13438 1 1 4.13438 1 8C1 11.8656 4.13438 15 8 15C11.8656 15 15 11.8656 15 8C15 4.13438 11.8656 1 8 1ZM10.5844 10.6594L9.55313 10.6547L8 8.80313L6.44844 10.6531L5.41563 10.6578C5.34688 10.6578 5.29063 10.6031 5.29063 10.5328C5.29063 10.5031 5.30156 10.475 5.32031 10.4516L7.35313 8.02969L5.32031 5.60938C5.30143 5.58647 5.29096 5.5578 5.29063 5.52812C5.29063 5.45937 5.34688 5.40312 5.41563 5.40312L6.44844 5.40781L8 7.25938L9.55156 5.40938L10.5828 5.40469C10.6516 5.40469 10.7078 5.45937 10.7078 5.52969C10.7078 5.55937 10.6969 5.5875 10.6781 5.61094L8.64844 8.03125L10.6797 10.4531C10.6984 10.4766 10.7094 10.5047 10.7094 10.5344C10.7094 10.6031 10.6531 10.6594 10.5844 10.6594Z'
        fill='black'
        fillOpacity='0.88'
      />
    </svg>
  )
}

export const InfoCircleFilledIcon: FC<Props> = ({ className }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      className={className}
    >
      <path
        d='M12 1.5C6.20156 1.5 1.5 6.20156 1.5 12C1.5 17.7984 6.20156 22.5 12 22.5C17.7984 22.5 22.5 17.7984 22.5 12C22.5 6.20156 17.7984 1.5 12 1.5ZM12.75 17.0625C12.75 17.1656 12.6656 17.25 12.5625 17.25H11.4375C11.3344 17.25 11.25 17.1656 11.25 17.0625V10.6875C11.25 10.5844 11.3344 10.5 11.4375 10.5H12.5625C12.6656 10.5 12.75 10.5844 12.75 10.6875V17.0625ZM12 9C11.7056 8.99399 11.4253 8.87282 11.2192 8.6625C11.0132 8.45218 10.8977 8.16945 10.8977 7.875C10.8977 7.58055 11.0132 7.29782 11.2192 7.0875C11.4253 6.87718 11.7056 6.75601 12 6.75C12.2944 6.75601 12.5747 6.87718 12.7808 7.0875C12.9868 7.29782 13.1023 7.58055 13.1023 7.875C13.1023 8.16945 12.9868 8.45218 12.7808 8.6625C12.5747 8.87282 12.2944 8.99399 12 9Z'
        fill='white'
      />
    </svg>
  )
}

export const CloseFilledIcon: FC<Props> = ({ className }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      className={className}
    >
      <path
        d='M8.81974 10L4.10565 5.28593L5.28416 4.10742L9.99825 8.82151L14.7123 4.10742L15.8909 5.28593L11.1768 10L15.8908 14.714L14.7123 15.8925L9.99825 11.1785L5.28425 15.8925L4.10574 14.714L8.81974 10Z'
        fill='white'
      />
    </svg>
  )
}

export const ServerIcon: FC<Props> = ({ className }) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      d='M20 2H4C2.89543 2 2 2.89543 2 4V8C2 9.10457 2.89543 10 4 10H20C21.1046 10 22 9.10457 22 8V4C22 2.89543 21.1046 2 20 2Z'
      stroke='#2E1F36'
      strokeOpacity='0.9'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M20 2H4C2.89543 2 2 2.89543 2 4V8C2 9.10457 2.89543 10 4 10H20C21.1046 10 22 9.10457 22 8V4C22 2.89543 21.1046 2 20 2Z'
      stroke='black'
      strokeOpacity='0.2'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M20 14H4C2.89543 14 2 14.8954 2 16V20C2 21.1046 2.89543 22 4 22H20C21.1046 22 22 21.1046 22 20V16C22 14.8954 21.1046 14 20 14Z'
      stroke='#2E1F36'
      strokeOpacity='0.9'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M20 14H4C2.89543 14 2 14.8954 2 16V20C2 21.1046 2.89543 22 4 22H20C21.1046 22 22 21.1046 22 20V16C22 14.8954 21.1046 14 20 14Z'
      stroke='black'
      strokeOpacity='0.2'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M6 6H6.01'
      stroke='#2E1F36'
      strokeOpacity='0.9'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M6 6H6.01'
      stroke='black'
      strokeOpacity='0.2'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M6 18H6.01'
      stroke='#2E1F36'
      strokeOpacity='0.9'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M6 18H6.01'
      stroke='black'
      strokeOpacity='0.2'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export const CopyIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M13.3333 6H7.33333C6.59695 6 6 6.59695 6 7.33333V13.3333C6 14.0697 6.59695 14.6667 7.33333 14.6667H13.3333C14.0697 14.6667 14.6667 14.0697 14.6667 13.3333V7.33333C14.6667 6.59695 14.0697 6 13.3333 6Z'
      stroke='currentColor'
      strokeOpacity='0.88'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M3.3335 9.99992H2.66683C2.31321 9.99992 1.97407 9.85944 1.72402 9.60939C1.47397 9.35935 1.3335 9.02021 1.3335 8.66659V2.66659C1.3335 2.31296 1.47397 1.97382 1.72402 1.72378C1.97407 1.47373 2.31321 1.33325 2.66683 1.33325H8.66683C9.02045 1.33325 9.35959 1.47373 9.60964 1.72378C9.85969 1.97382 10.0002 2.31296 10.0002 2.66659V3.33325'
      stroke='currentColor'
      strokeOpacity='0.88'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export const CheckIcon: FC<Props> = ({ className }) => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      d='M6 7.33317L8 9.33317L14.6667 2.6665'
      stroke='black'
      strokeOpacity='0.88'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M14 8V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V3.33333C2 2.97971 2.14048 2.64057 2.39052 2.39052C2.64057 2.14048 2.97971 2 3.33333 2H10.6667'
      stroke='black'
      strokeOpacity='0.88'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export const EyeIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2.75197 8.00296C4.50829 11.2614 7.06545 11.9998 7.99926 11.9998H8.0295L8.05962 12.0026C9.25118 12.1109 10.3753 11.5062 11.3466 10.5765C12.2055 9.75457 12.872 8.74475 13.2629 7.98666C11.7527 4.75964 9.06838 3.99984 7.99926 3.99984C6.77246 3.99984 5.62288 4.65372 4.64711 5.56933C3.80176 6.36255 3.14473 7.29959 2.75197 8.00296ZM3.73475 4.59702C4.8312 3.56818 6.29273 2.6665 7.99926 2.6665C9.567 2.6665 12.8948 3.7304 14.612 7.73722L14.7295 8.01143L14.6034 8.28176C14.187 9.17409 13.3758 10.48 12.2686 11.5398C11.1739 12.5875 9.69746 13.4787 7.9684 13.333C6.47359 13.3181 3.36544 12.2229 1.40298 8.29798L1.25391 7.99984L1.40298 7.70169C1.82146 6.86473 2.63267 5.63114 3.73475 4.59702ZM7.99926 6.6665C7.26288 6.6665 6.66593 7.26346 6.66593 7.99984C6.66593 8.73622 7.26288 9.33317 7.99926 9.33317C8.73564 9.33317 9.3326 8.73622 9.3326 7.99984C9.3326 7.26346 8.73564 6.6665 7.99926 6.6665ZM5.3326 7.99984C5.3326 6.52708 6.5265 5.33317 7.99926 5.33317C9.47202 5.33317 10.6659 6.52708 10.6659 7.99984C10.6659 9.4726 9.47202 10.6665 7.99926 10.6665C6.5265 10.6665 5.3326 9.4726 5.3326 7.99984Z'
      fill='currentColor'
      fillOpacity='0.45'
    />
  </svg>
)

export const EyeSlashIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.69067 4.63495L0.860352 1.80463L1.80316 0.861816L11.4268 10.4854C11.4304 10.4818 11.4341 10.4782 11.4378 10.4746L12.3742 11.4237C12.3727 11.4252 12.3711 11.4268 12.3696 11.4283L15.1365 14.1951L14.1937 15.138L11.3463 12.2906C10.3935 12.9641 9.25003 13.4256 7.96761 13.3177C6.47339 13.3029 3.36509 12.2098 1.40233 8.29074L1.25282 7.99221L1.40233 7.69367C1.81293 6.87383 2.60741 5.66204 3.69067 4.63495ZM4.63386 5.57813C3.79709 6.36499 3.14397 7.29363 2.75141 7.99533C4.50746 11.2471 7.06413 11.9845 7.99842 11.9845H8.02861L8.05868 11.9873C8.87597 12.0614 9.66144 11.8006 10.3868 11.3311L9.35324 10.2975C8.33064 10.9015 6.99142 10.7642 6.11279 9.88553C5.23416 9.0069 5.09683 7.66769 5.70081 6.64508L4.63386 5.57813ZM6.71034 7.65461C6.59153 8.09944 6.70662 8.59374 7.0556 8.94273C7.40458 9.29171 7.89889 9.40679 8.34372 9.28799L6.71034 7.65461ZM7.99842 3.99989C7.61186 3.99989 7.23446 4.06417 6.86724 4.18102L6.46294 2.91046C6.9482 2.75605 7.46194 2.66655 7.99842 2.66655C9.56553 2.66655 12.8935 3.72835 14.611 7.72923L14.7289 8.00381L14.6024 8.27451C14.3087 8.90283 13.824 9.72563 13.1851 10.522L12.1451 9.68753C12.6247 9.08988 13.0044 8.47723 13.2619 7.979C11.7518 4.75863 9.06804 3.99989 7.99842 3.99989Z'
      fill='currentColor'
      fillOpacity='0.45'
    />
  </svg>
)

// Loading spinner
export const LoadingSpinner = ({ clipPathId }: { clipPathId: string }) => (
  <div className='w-6 h-6 flex items-center justify-center'>
    <svg
      className='animate-spin'
      xmlns='http://www.w3.org/2000/svg'
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
    >
      <g clipPath='url(#clip0_156_3544)'>
        <path
          d='M9 18C7.78535 18 6.60586 17.7627 5.49668 17.2934C4.42441 16.8398 3.46289 16.1895 2.63672 15.3633C1.81055 14.5371 1.16016 13.5756 0.706641 12.5033C0.237305 11.3941 0 10.2146 0 9C0 8.6502 0.283008 8.36719 0.632812 8.36719C0.982617 8.36719 1.26562 8.6502 1.26562 9C1.26562 10.0441 1.46953 11.0566 1.87383 12.0111C2.26406 12.9322 2.82129 13.7602 3.53145 14.4703C4.2416 15.1805 5.06953 15.7395 5.99062 16.1279C6.94336 16.5305 7.95586 16.7344 9 16.7344C10.0441 16.7344 11.0566 16.5305 12.0111 16.1262C12.9322 15.7359 13.7602 15.1787 14.4703 14.4686C15.1805 13.7584 15.7395 12.9305 16.1279 12.0094C16.5305 11.0566 16.7344 10.0441 16.7344 9C16.7344 7.95586 16.5305 6.94336 16.1262 5.98887C15.7373 5.06999 15.1744 4.23494 14.4686 3.52969C13.7641 2.8229 12.9288 2.25991 12.0094 1.87207C11.0566 1.46953 10.0441 1.26562 9 1.26562C8.6502 1.26562 8.36719 0.982617 8.36719 0.632812C8.36719 0.283008 8.6502 0 9 0C10.2146 0 11.3941 0.237305 12.5033 0.706641C13.5756 1.16016 14.5371 1.81055 15.3633 2.63672C16.1895 3.46289 16.8381 4.42617 17.2916 5.49668C17.7609 6.60586 17.9982 7.78535 17.9982 9C17.9982 10.2146 17.7609 11.3941 17.2916 12.5033C16.8398 13.5756 16.1895 14.5371 15.3633 15.3633C14.5371 16.1895 13.5738 16.8381 12.5033 17.2916C11.3941 17.7627 10.2146 18 9 18Z'
          fill='black'
          fillOpacity='0.45'
        />
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <rect width='18' height='18' fill='white' />
        </clipPath>
      </defs>
    </svg>
  </div>
)

// toast message check icon
export const ToastMessageCheckIcon: FC<Props> = ({ className }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      className={className}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM17.2071 9.20711L15.7929 7.79289L10 13.5858L7.70711 11.2929L6.29289 12.7071L10 16.4142L17.2071 9.20711Z'
        fill='white'
      />
    </svg>
  )
}

export const NewGearIcon: FC<Props> = ({ className }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      className={className}
    >
      <g clipPath='url(#clip0_1142_49)'>
        <path
          d='M8 5.00003C7.40665 5.00003 6.82664 5.17598 6.33329 5.50562C5.83994 5.83526 5.45542 6.3038 5.22836 6.85198C5.0013 7.40016 4.94189 8.00336 5.05764 8.5853C5.1734 9.16724 5.45912 9.70179 5.87868 10.1214C6.29824 10.5409 6.83278 10.8266 7.41473 10.9424C7.99667 11.0581 8.59987 10.9987 9.14805 10.7717C9.69623 10.5446 10.1648 10.1601 10.4944 9.66674C10.8241 9.17339 11 8.59337 11 8.00003C10.9992 7.20463 10.6828 6.44205 10.1204 5.87962C9.55798 5.31719 8.79539 5.00086 8 5.00003ZM8 10C7.60444 10 7.21776 9.88273 6.88886 9.66297C6.55996 9.44321 6.30361 9.13085 6.15224 8.7654C6.00086 8.39994 5.96126 7.99781 6.03843 7.60985C6.1156 7.22189 6.30608 6.86552 6.58578 6.58582C6.86549 6.30611 7.22186 6.11563 7.60982 6.03846C7.99778 5.96129 8.39991 6.00089 8.76537 6.15227C9.13082 6.30365 9.44318 6.55999 9.66294 6.88889C9.8827 7.21779 10 7.60447 10 8.00003C10 8.53046 9.78928 9.03917 9.41421 9.41424C9.03914 9.78932 8.53043 10 8 10ZM13.5 8.13503C13.5025 8.04503 13.5025 7.95503 13.5 7.86503L14.4325 6.70003C14.4814 6.63886 14.5152 6.56706 14.5313 6.49042C14.5474 6.41378 14.5452 6.33443 14.525 6.25878C14.3721 5.68415 14.1435 5.13244 13.845 4.61815C13.8059 4.55085 13.7517 4.4936 13.6866 4.45096C13.6215 4.40832 13.5473 4.38146 13.47 4.37253L11.9875 4.20753C11.9258 4.14253 11.8633 4.08003 11.8 4.02003L11.625 2.53378C11.616 2.45641 11.589 2.38222 11.5463 2.31711C11.5035 2.252 11.4462 2.19779 11.3787 2.15878C10.8643 1.86087 10.3126 1.63243 9.73812 1.4794C9.66242 1.45928 9.58305 1.45722 9.5064 1.47339C9.42976 1.48957 9.35799 1.52353 9.29687 1.57253L8.135 2.50003C8.045 2.50003 7.955 2.50003 7.865 2.50003L6.7 1.5694C6.63883 1.52051 6.56703 1.48666 6.49039 1.4706C6.41375 1.45453 6.3344 1.45669 6.25875 1.4769C5.68422 1.63005 5.13253 1.85871 4.61812 2.1569C4.55082 2.19598 4.49357 2.25023 4.45093 2.31533C4.40829 2.38044 4.38143 2.45459 4.3725 2.5319L4.2075 4.0169C4.1425 4.07899 4.08 4.14149 4.02 4.2044L2.53375 4.37503C2.45638 4.38403 2.38219 4.41098 2.31708 4.45373C2.25197 4.49649 2.19776 4.55386 2.15875 4.62128C1.86084 5.13576 1.63239 5.68743 1.47937 6.2619C1.45925 6.33761 1.45719 6.41698 1.47336 6.49362C1.48954 6.57027 1.5235 6.64204 1.5725 6.70315L2.5 7.86503C2.5 7.95503 2.5 8.04503 2.5 8.13503L1.56937 9.30003C1.52048 9.3612 1.48663 9.43299 1.47057 9.50964C1.4545 9.58628 1.45666 9.66562 1.47687 9.74128C1.62974 10.3159 1.85842 10.8676 2.15687 11.3819C2.19595 11.4492 2.2502 11.5065 2.3153 11.5491C2.38041 11.5917 2.45456 11.6186 2.53187 11.6275L4.01437 11.7925C4.07646 11.8575 4.13896 11.92 4.20187 11.98L4.375 13.4663C4.384 13.5436 4.41095 13.6178 4.4537 13.6829C4.49646 13.7481 4.55383 13.8023 4.62125 13.8413C5.13573 14.1392 5.6874 14.3676 6.26187 14.5207C6.33758 14.5408 6.41695 14.5428 6.49359 14.5267C6.57024 14.5105 6.64201 14.4765 6.70312 14.4275L7.865 13.5C7.955 13.5025 8.045 13.5025 8.135 13.5L9.3 14.4325C9.36117 14.4814 9.43296 14.5153 9.50961 14.5313C9.58625 14.5474 9.66559 14.5452 9.74125 14.525C10.3159 14.3722 10.8676 14.1435 11.3819 13.845C11.4492 13.806 11.5064 13.7517 11.5491 13.6866C11.5917 13.6215 11.6186 13.5473 11.6275 13.47L11.7925 11.9875C11.8575 11.9259 11.92 11.8634 11.98 11.8L13.4663 11.625C13.5436 11.616 13.6178 11.5891 13.6829 11.5463C13.748 11.5036 13.8022 11.4462 13.8413 11.3788C14.1392 10.8643 14.3676 10.3126 14.5206 9.73815C14.5408 9.66245 14.5428 9.58308 14.5266 9.50643C14.5105 9.42979 14.4765 9.35802 14.4275 9.2969L13.5 8.13503ZM12.4937 7.72878C12.5044 7.90946 12.5044 8.0906 12.4937 8.27128C12.4863 8.39498 12.5251 8.51703 12.6025 8.61378L13.4894 9.7219C13.3876 10.0453 13.2573 10.3591 13.1 10.6594L11.6875 10.8194C11.5645 10.8331 11.4509 10.8919 11.3687 10.9844C11.2484 11.1197 11.1203 11.2478 10.985 11.3682C10.8924 11.4503 10.8337 11.5639 10.82 11.6869L10.6631 13.0982C10.3628 13.2555 10.0491 13.3858 9.72562 13.4875L8.61687 12.6007C8.52815 12.5298 8.41794 12.4912 8.30437 12.4913H8.27437C8.0937 12.5019 7.91255 12.5019 7.73187 12.4913C7.60818 12.4838 7.48612 12.5226 7.38937 12.6L6.27812 13.4875C5.95471 13.3858 5.64097 13.2555 5.34062 13.0982L5.18062 11.6875C5.16697 11.5645 5.10818 11.4509 5.01562 11.3688C4.88032 11.2485 4.75218 11.1203 4.63187 10.985C4.54971 10.8925 4.43613 10.8337 4.31312 10.82L2.90187 10.6625C2.74449 10.3622 2.61419 10.0485 2.5125 9.72503L3.39937 8.61628C3.47681 8.51953 3.51557 8.39748 3.50812 8.27378C3.4975 8.0931 3.4975 7.91196 3.50812 7.73128C3.51557 7.60758 3.47681 7.48552 3.39937 7.38878L2.5125 6.27815C2.61426 5.95474 2.74457 5.641 2.90187 5.34065L4.3125 5.18065C4.43551 5.167 4.54908 5.10821 4.63125 5.01565C4.75155 4.88035 4.87969 4.75221 5.015 4.6319C5.10792 4.54968 5.16695 4.43585 5.18062 4.31253L5.3375 2.9019C5.63781 2.74452 5.95155 2.61422 6.275 2.51253L7.38375 3.3994C7.48049 3.47684 7.60255 3.5156 7.72625 3.50815C7.90693 3.49753 8.08807 3.49753 8.26875 3.50815C8.39245 3.5156 8.5145 3.47684 8.61125 3.3994L9.72187 2.51253C10.0453 2.61429 10.359 2.7446 10.6594 2.9019L10.8194 4.31253C10.833 4.43554 10.8918 4.54911 10.9844 4.63128C11.1197 4.75159 11.2478 4.87972 11.3681 5.01503C11.4503 5.10758 11.5639 5.16637 11.6869 5.18003L13.0981 5.3369C13.2555 5.63722 13.3858 5.95096 13.4875 6.2744L12.6006 7.38315C12.5224 7.48071 12.4836 7.60403 12.4919 7.72878H12.4937Z'
          fill='#262626'
        />
      </g>
      <defs>
        <clipPath id='clip0_1142_49'>
          <rect width='16' height='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

// Loading spinner
export const FileUpLoadingSpinner = ({ clipPathId }: { clipPathId: string }) => (
  <div className='w-6 h-6 flex items-center justify-center'>
    <svg
      className='animate-spin'
      xmlns='http://www.w3.org/2000/svg'
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
    >
      <g clipPath='url(#clip0_156_3544)'>
        <path
          d='M9 18C7.78535 18 6.60586 17.7627 5.49668 17.2934C4.42441 16.8398 3.46289 16.1895 2.63672 15.3633C1.81055 14.5371 1.16016 13.5756 0.706641 12.5033C0.237305 11.3941 0 10.2146 0 9C0 8.6502 0.283008 8.36719 0.632812 8.36719C0.982617 8.36719 1.26562 8.6502 1.26562 9C1.26562 10.0441 1.46953 11.0566 1.87383 12.0111C2.26406 12.9322 2.82129 13.7602 3.53145 14.4703C4.2416 15.1805 5.06953 15.7395 5.99062 16.1279C6.94336 16.5305 7.95586 16.7344 9 16.7344C10.0441 16.7344 11.0566 16.5305 12.0111 16.1262C12.9322 15.7359 13.7602 15.1787 14.4703 14.4686C15.1805 13.7584 15.7395 12.9305 16.1279 12.0094C16.5305 11.0566 16.7344 10.0441 16.7344 9C16.7344 7.95586 16.5305 6.94336 16.1262 5.98887C15.7373 5.06999 15.1744 4.23494 14.4686 3.52969C13.7641 2.8229 12.9288 2.25991 12.0094 1.87207C11.0566 1.46953 10.0441 1.26562 9 1.26562C8.6502 1.26562 8.36719 0.982617 8.36719 0.632812C8.36719 0.283008 8.6502 0 9 0C10.2146 0 11.3941 0.237305 12.5033 0.706641C13.5756 1.16016 14.5371 1.81055 15.3633 2.63672C16.1895 3.46289 16.8381 4.42617 17.2916 5.49668C17.7609 6.60586 17.9982 7.78535 17.9982 9C17.9982 10.2146 17.7609 11.3941 17.2916 12.5033C16.8398 13.5756 16.1895 14.5371 15.3633 15.3633C14.5371 16.1895 13.5738 16.8381 12.5033 17.2916C11.3941 17.7627 10.2146 18 9 18Z'
          fill='black'
          fillOpacity='0.45'
        />
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <rect width='18' height='18' fill='white' />
        </clipPath>
      </defs>
    </svg>
  </div>
)

// test button success icon
export const TestButtonSuccessIcon: FC<Props> = ({ className }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      className={className}
    >
      <path
        d='M8 1C4.13438 1 1 4.13438 1 8C1 11.8656 4.13438 15 8 15C11.8656 15 15 11.8656 15 8C15 4.13438 11.8656 1 8 1ZM11.0234 5.71406L7.73281 10.2766C7.68682 10.3408 7.62619 10.3931 7.55595 10.4291C7.48571 10.4652 7.40787 10.4841 7.32891 10.4841C7.24994 10.4841 7.17211 10.4652 7.10186 10.4291C7.03162 10.3931 6.97099 10.3408 6.925 10.2766L4.97656 7.57656C4.91719 7.49375 4.97656 7.37813 5.07812 7.37813H5.81094C5.97031 7.37813 6.12187 7.45469 6.21562 7.58594L7.32812 9.12969L9.78438 5.72344C9.87813 5.59375 10.0281 5.51562 10.1891 5.51562H10.9219C11.0234 5.51562 11.0828 5.63125 11.0234 5.71406V5.71406Z'
        fill='#36A764'
      />
    </svg>
  )
}

// test button error icon
export const TestButtonErrorIcon: FC<Props> = ({ className }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      className={className}
    >
      <path
        d='M8 1C4.13438 1 1 4.13438 1 8C1 11.8656 4.13438 15 8 15C11.8656 15 15 11.8656 15 8C15 4.13438 11.8656 1 8 1ZM8 13.8125C4.79063 13.8125 2.1875 11.2094 2.1875 8C2.1875 4.79063 4.79063 2.1875 8 2.1875C11.2094 2.1875 13.8125 4.79063 13.8125 8C13.8125 11.2094 11.2094 13.8125 8 13.8125Z'
        fill='#D94B36'
      />
      <path
        d='M7.25 10.75C7.25 10.9489 7.32902 11.1397 7.46967 11.2803C7.61032 11.421 7.80109 11.5 8 11.5C8.19891 11.5 8.38968 11.421 8.53033 11.2803C8.67098 11.1397 8.75 10.9489 8.75 10.75C8.75 10.5511 8.67098 10.3603 8.53033 10.2197C8.38968 10.079 8.19891 10 8 10C7.80109 10 7.61032 10.079 7.46967 10.2197C7.32902 10.3603 7.25 10.5511 7.25 10.75ZM7.625 9H8.375C8.44375 9 8.5 8.94375 8.5 8.875V4.625C8.5 4.55625 8.44375 4.5 8.375 4.5H7.625C7.55625 4.5 7.5 4.55625 7.5 4.625V8.875C7.5 8.94375 7.55625 9 7.625 9Z'
        fill='#D94B36'
      />
    </svg>
  )
}

// loading icon
export const LoadingIcon: FC<Props> = ({ className }) => {
  return (
    <svg className='animate-spin h-4 w-4' viewBox='0 0 24 24'>
      <circle className='opacity-25' cx='12' cy='12' r='10' stroke='currentColor' strokeWidth='4' />
      <path
        className='opacity-75'
        fill='currentColor'
        d='M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z'
      />
    </svg>
  )
}

export const UpgradeIcon: FC<Props> = ({ className }) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
      <path
        opacity='0.1'
        d='M14.2488 4.43516V4.44297L13.0551 13.5148C13.0395 13.6398 12.9316 13.7336 12.8066 13.7336H3.1957C3.06914 13.7336 2.96289 13.6383 2.9457 13.5148L1.75195 4.44297V4.43359V4.45859L2.9457 13.5305C2.96289 13.6539 3.06914 13.7492 3.1957 13.7492H12.8066C12.9316 13.7492 13.0395 13.6555 13.0551 13.5305L14.2488 4.45859C14.2504 4.45078 14.2504 4.44297 14.2488 4.43516Z'
        fill='#65558F'
      />
      <path
        opacity='0.1'
        d='M12.0875 12.6652L12.9297 6.26836L10.7453 7.61367L8 3.95117L5.25469 7.61367L3.07031 6.26836L3.91094 12.6652H12.0875ZM6.24062 9.71211C6.24062 8.7418 7.02969 7.95273 8 7.95273C8.97031 7.95273 9.75937 8.7418 9.75937 9.71211V9.72773C9.75937 10.698 8.97031 11.4871 8 11.4871C7.02969 11.4871 6.24062 10.698 6.24062 9.72773V9.71211Z'
        fill='#65558F'
      />
      <path
        d='M7.99962 11.4719C8.96681 11.4719 9.75432 10.6875 9.759 9.72031V9.7125C9.759 8.74219 8.96994 7.95312 7.99962 7.95312C7.0293 7.95312 6.24023 8.74219 6.24023 9.7125V9.72031C6.24492 10.6875 7.03243 11.4719 7.99962 11.4719ZM7.99962 8.95781C8.41525 8.95781 8.75275 9.29531 8.75275 9.7125C8.75275 10.1281 8.41525 10.4672 7.99962 10.4672C7.58399 10.4672 7.24649 10.1297 7.24649 9.7125C7.24649 9.29687 7.58399 8.95781 7.99962 8.95781Z'
        fill='#65558F'
      />
      <path
        d='M2.94596 13.5153C2.96314 13.6387 3.06939 13.734 3.19596 13.734H12.8069C12.9319 13.734 13.0397 13.6403 13.0553 13.5153L14.2491 4.44339V4.43557C14.2538 4.33557 14.1444 4.26682 14.0569 4.31995L11.0163 6.19339L8.10064 2.30432C8.08891 2.28867 8.0737 2.27596 8.05621 2.26721C8.03871 2.25846 8.01942 2.25391 7.99986 2.25391C7.9803 2.25391 7.96101 2.25846 7.94352 2.26721C7.92602 2.27596 7.91081 2.28867 7.89908 2.30432L4.98502 6.19339L1.94283 4.31995C1.85689 4.26682 1.74596 4.33401 1.75221 4.43401V4.44339L2.94596 13.5153ZM5.25533 7.6137L8.00064 3.9512L10.746 7.6137L12.9303 6.26839L12.0881 12.6653H3.91158L3.07096 6.26839L5.25533 7.6137Z'
        fill='#65558F'
      />
    </svg>
  )
}

export const RightArrowIcon: FC<Props> = ({ className }) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
      <path
        d='M13.5781 7.62187L7.675 2.49844C7.62969 2.45937 7.57188 2.4375 7.51094 2.4375H6.12813C6.0125 2.4375 5.95937 2.58125 6.04688 2.65625L11.5188 7.40625H2.375C2.30625 7.40625 2.25 7.4625 2.25 7.53125V8.46875C2.25 8.5375 2.30625 8.59375 2.375 8.59375H11.5172L6.04531 13.3438C5.95781 13.4203 6.01094 13.5625 6.12656 13.5625H7.55625C7.58594 13.5625 7.61562 13.5516 7.6375 13.5312L13.5781 8.37813C13.6322 8.33109 13.6756 8.27299 13.7053 8.20776C13.735 8.14253 13.7504 8.07168 13.7504 8C13.7504 7.92832 13.735 7.85747 13.7053 7.79224C13.6756 7.72701 13.6322 7.66891 13.5781 7.62187Z'
        fill='#846FE1'
      />
    </svg>
  )
}

export const ManageRightArrowIcon: FC<Props> = ({ className }) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
      <g clipPath='url(#clip0_1059_1932)'>
        <path
          d='M11.354 8.35403L6.35403 13.354C6.30757 13.4005 6.25242 13.4373 6.19173 13.4625C6.13103 13.4876 6.06598 13.5006 6.00028 13.5006C5.93458 13.5006 5.86953 13.4876 5.80883 13.4625C5.74813 13.4373 5.69298 13.4005 5.64653 13.354C5.60007 13.3076 5.56322 13.2524 5.53808 13.1917C5.51294 13.131 5.5 13.066 5.5 13.0003C5.5 12.9346 5.51294 12.8695 5.53808 12.8088C5.56322 12.7481 5.60007 12.693 5.64653 12.6465L10.2934 8.00028L5.64653 3.35403C5.55271 3.26021 5.5 3.13296 5.5 3.00028C5.5 2.8676 5.55271 2.74035 5.64653 2.64653C5.74035 2.55271 5.8676 2.5 6.00028 2.5C6.13296 2.5 6.26021 2.55271 6.35403 2.64653L11.354 7.64653C11.4005 7.69296 11.4374 7.74811 11.4626 7.80881C11.4877 7.86951 11.5007 7.93457 11.5007 8.00028C11.5007 8.06599 11.4877 8.13105 11.4626 8.19175C11.4374 8.25245 11.4005 8.30759 11.354 8.35403Z'
          fill='#262626'
        />
      </g>
      <defs>
        <clipPath id='clip0_1059_1932'>
          <rect width='16' height='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export const BottomArrowIcon: FC<Props> = ({ className }) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
      <g clipPath='url(#clip0_1043_9446)'>
        <path
          d='M13.354 6.35354L8.35403 11.3535C8.30759 11.4 8.25245 11.4369 8.19175 11.4621C8.13105 11.4872 8.06599 11.5002 8.00028 11.5002C7.93457 11.5002 7.86951 11.4872 7.80881 11.4621C7.74811 11.4369 7.69296 11.4 7.64653 11.3535L2.64653 6.35354C2.55271 6.25972 2.5 6.13247 2.5 5.99979C2.5 5.86711 2.55271 5.73986 2.64653 5.64604C2.74035 5.55222 2.8676 5.49951 3.00028 5.49951C3.13296 5.49951 3.26021 5.55222 3.35403 5.64604L8.00028 10.2929L12.6465 5.64604C12.693 5.59958 12.7481 5.56273 12.8088 5.53759C12.8695 5.51245 12.9346 5.49951 13.0003 5.49951C13.066 5.49951 13.131 5.51245 13.1917 5.53759C13.2524 5.56273 13.3076 5.59958 13.354 5.64604C13.4005 5.69249 13.4373 5.74764 13.4625 5.80834C13.4876 5.86904 13.5006 5.93409 13.5006 5.99979C13.5006 6.06549 13.4876 6.13054 13.4625 6.19124C13.4373 6.25193 13.4005 6.30708 13.354 6.35354Z'
          fill='#262626'
        />
      </g>
      <defs>
        <clipPath id='clip0_1043_9446'>
          <rect width='16' height='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export const CloseIcon: FC<Props> = ({ className }) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <path
        d='M19.281 18.2193C19.3507 18.289 19.406 18.3717 19.4437 18.4628C19.4814 18.5538 19.5008 18.6514 19.5008 18.7499C19.5008 18.8485 19.4814 18.9461 19.4437 19.0371C19.406 19.1281 19.3507 19.2109 19.281 19.2806C19.2114 19.3502 19.1286 19.4055 19.0376 19.4432C18.9465 19.4809 18.849 19.5003 18.7504 19.5003C18.6519 19.5003 18.5543 19.4809 18.4632 19.4432C18.3722 19.4055 18.2895 19.3502 18.2198 19.2806L12.0004 13.0602L5.78104 19.2806C5.64031 19.4213 5.44944 19.5003 5.25042 19.5003C5.05139 19.5003 4.86052 19.4213 4.71979 19.2806C4.57906 19.1398 4.5 18.949 4.5 18.7499C4.5 18.5509 4.57906 18.36 4.71979 18.2193L10.9401 11.9999L4.71979 5.78055C4.57906 5.63982 4.5 5.44895 4.5 5.24993C4.5 5.05091 4.57906 4.86003 4.71979 4.7193C4.86052 4.57857 5.05139 4.49951 5.25042 4.49951C5.44944 4.49951 5.64031 4.57857 5.78104 4.7193L12.0004 10.9396L18.2198 4.7193C18.3605 4.57857 18.5514 4.49951 18.7504 4.49951C18.9494 4.49951 19.1403 4.57857 19.281 4.7193C19.4218 4.86003 19.5008 5.05091 19.5008 5.24993C19.5008 5.44895 19.4218 5.63982 19.281 5.78055L13.0607 11.9999L19.281 18.2193Z'
        fill='#262626'
      />
    </svg>
  )
}

export const UserIcon: FC<Props> = ({ className }) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14' fill='none'>
      <path
        d='M7 2.05859C8.5969 2.05859 9.89062 3.35231 9.89062 4.94922C9.89062 5.91281 9.41938 6.76687 8.69238 7.29199L8.02344 7.77539L8.76172 8.14453C8.77266 8.15 8.78284 8.15372 8.79102 8.15723L8.79199 8.1582L8.80664 8.16504C9.35772 8.39826 9.85855 8.73562 10.2812 9.15918L10.2822 9.16016C10.7061 9.58239 11.0437 10.0836 11.2764 10.6348L11.7373 10.4395L11.2773 10.6348C11.4547 11.0535 11.5673 11.4913 11.6152 11.9414H11.5752C11.4629 10.9019 11.0039 9.93758 10.2549 9.18848C9.38594 8.31953 8.22912 7.83984 7 7.83984C5.77089 7.83985 4.61405 8.31954 3.74512 9.18848C2.99615 9.93758 2.5371 10.9019 2.4248 11.9414H2.38477C2.43262 11.493 2.54583 11.0532 2.72266 10.6367L2.72363 10.6357C2.95687 10.0847 3.29424 9.58378 3.71777 9.16113L3.71875 9.16016C4.14397 8.73375 4.63819 8.40003 5.18945 8.16699C5.19198 8.16602 5.19558 8.16554 5.19922 8.16406C5.20107 8.16331 5.20291 8.16204 5.20508 8.16113L5.20801 8.16016L5.20996 8.1582C5.21798 8.15474 5.22771 8.15079 5.23828 8.14551L5.97559 7.77734L5.30762 7.29395C4.58022 6.7673 4.10938 5.91266 4.10938 4.94922C4.10938 3.35233 5.40311 2.05861 7 2.05859ZM5.19043 8.16699C5.18731 8.16826 5.18494 8.1694 5.18359 8.16992H5.18262C5.18348 8.1696 5.18544 8.16876 5.1875 8.16797L5.19043 8.16699ZM7 2.09766C6.23972 2.09767 5.52237 2.3956 4.98438 2.93359C4.44638 3.4716 4.14844 4.18894 4.14844 4.94922C4.14844 5.7095 4.44638 6.42684 4.98438 6.96484C5.52237 7.50284 6.23972 7.80077 7 7.80078C7.76028 7.80078 8.47762 7.50284 9.01562 6.96484C9.55363 6.42684 9.85156 5.70951 9.85156 4.94922C9.85156 4.18893 9.55363 3.4716 9.01562 2.93359C8.47762 2.3956 7.76028 2.09766 7 2.09766ZM4.82617 7.23633L4.82227 7.2373C4.82565 7.23593 4.82872 7.2349 4.83008 7.23438H4.83105C4.83034 7.23464 4.82839 7.23548 4.82617 7.23633Z'
        stroke='black'
        strokeOpacity='0.88'
      />
    </svg>
  )
}

export const PlanCheckIcon: FC<Props> = ({ className }) => {
  return (
    <svg className='w-4 h-4' fill='currentColor' viewBox='0 0 20 20' style={{ color: '#65558F' }}>
      <path
        fillRule='evenodd'
        d='M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z'
        clipRule='evenodd'
      />
    </svg>
  )
}

export const ErrorIconCross: FC<Props> = ({ className }) => {
  return (
    <svg
      width='14'
      height='14'
      viewBox='0 0 14 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M7 0C3.13438 0 0 3.13438 0 7C0 10.8656 3.13438 14 7 14C10.8656 14 14 10.8656 14 7C14 3.13438 10.8656 0 7 0ZM9.58438 9.65938L8.55313 9.65469L7 7.80313L5.44844 9.65312L4.41563 9.65781C4.34688 9.65781 4.29063 9.60312 4.29063 9.53281C4.29063 9.50312 4.30156 9.475 4.32031 9.45156L6.35313 7.02969L4.32031 4.60938C4.30143 4.58647 4.29096 4.5578 4.29063 4.52812C4.29063 4.45937 4.34688 4.40312 4.41563 4.40312L5.44844 4.40781L7 6.25938L8.55156 4.40938L9.58281 4.40469C9.65156 4.40469 9.70781 4.45937 9.70781 4.52969C9.70781 4.55937 9.69688 4.5875 9.67813 4.61094L7.64844 7.03125L9.67969 9.45312C9.69844 9.47656 9.70938 9.50469 9.70938 9.53438C9.70938 9.60313 9.65313 9.65938 9.58438 9.65938Z'
        fill='#D94B36'
      />
    </svg>
  )
}

export const LogoIcon: FC<Props> = ({ className }) => {
  return (
    <svg
      width='140'
      height='27'
      viewBox='0 0 140 27'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <mask
        id='mask0_676_9160'
        style={{ maskType: 'luminance' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='140'
        height='27'
      >
        <path d='M140 0H0V26.5371H140V0Z' fill='white' />
      </mask>
      <g mask='url(#mask0_676_9160)'>
        <path
          d='M10.0506 23.429C8.2652 23.429 6.68776 23.0221 5.31842 22.2083C3.94907 21.3944 2.87436 20.2466 2.09429 18.7645C1.31435 17.2826 0.924316 15.5478 0.924316 13.5604C0.924316 11.5558 1.31435 9.81246 2.09429 8.33051C2.87436 6.84848 3.94907 5.70058 5.31842 4.88675C6.68776 4.07292 8.2652 3.66602 10.0506 3.66602C11.5066 3.66602 12.824 3.94871 14.0027 4.5141C15.1815 5.0795 16.1521 5.87619 16.9149 6.90417C17.6862 7.93215 18.1802 9.14433 18.3969 10.5407H14.8997C14.6398 9.32417 14.0808 8.3819 13.2227 7.71371C12.3647 7.04552 11.3159 6.71143 10.0766 6.71143C8.89788 6.71143 7.87959 6.99412 7.02153 7.55952C6.17219 8.12484 5.51779 8.92157 5.05849 9.94953C4.60775 10.9776 4.38239 12.1812 4.38239 13.5604C4.38239 14.9311 4.60775 16.1303 5.05849 17.1584C5.51779 18.1777 6.17219 18.9702 7.02153 19.5356C7.87088 20.1009 8.88917 20.3837 10.0766 20.3837C11.3072 20.3837 12.3517 20.0538 13.2097 19.3941C14.0678 18.7346 14.6353 17.7966 14.9127 16.58H18.3969C18.1802 17.9764 17.6862 19.1886 16.9149 20.2166C16.1521 21.2361 15.1815 22.0284 14.0027 22.5938C12.824 23.1507 11.5066 23.429 10.0506 23.429Z'
          fill='#65558F'
        />
        <path
          d='M24.0269 23.39C22.5883 23.39 21.4139 22.9316 20.5039 22.015C19.5938 21.0985 19.1388 19.7707 19.1388 18.0317V9.55078H22.4149V17.5175C22.4149 18.5113 22.6576 19.2652 23.143 19.7791C23.6283 20.2931 24.3087 20.5502 25.184 20.5502C26.0506 20.5502 26.7657 20.2846 27.329 19.7534C27.9012 19.2224 28.1871 18.3785 28.1871 17.2221V9.55078H31.4762V23.1201H28.2521V21.0385C27.29 22.6061 25.8817 23.39 24.0269 23.39Z'
          fill='#65558F'
        />
        <path
          d='M32.8052 23.1208V9.55153H35.9642V11.8001H36.0033C36.2545 11.0292 36.649 10.4424 37.1863 10.0398C37.7323 9.6286 38.8518 9.5 39.7359 9.5C39.9612 9.5 40.1606 9.50861 40.334 9.52569C40.516 9.5343 40.6719 9.54291 40.802 9.55153V12.4299C40.6806 12.4126 40.4725 12.3913 40.1779 12.3655C39.8833 12.3398 39.5756 12.327 39.2549 12.327C38.4749 12.327 37.4116 12.5154 36.8742 13.0466C36.3456 13.5777 36.0813 14.3744 36.0813 15.4367V23.1208H32.8052Z'
          fill='#65558F'
        />
        <path
          d='M40.8019 23.1214V9.55207H44.0778V23.1214H40.8019ZM42.4398 7.53457C41.8764 7.53457 41.4084 7.35896 41.0358 7.00773C40.6632 6.64793 40.4768 6.20677 40.4768 5.6842C40.4768 5.16164 40.6632 4.72475 41.0358 4.37352C41.4084 4.02229 41.8764 3.84668 42.4398 3.84668C42.9946 3.84668 43.4581 4.02229 43.8309 4.37352C44.2035 4.72475 44.3899 5.16164 44.3899 5.6842C44.3899 6.20677 44.2035 6.64793 43.8309 7.00773C43.4581 7.35896 42.9946 7.53457 42.4398 7.53457Z'
          fill='#65558F'
        />
        <path
          d='M51.4512 23.4293C50.0818 23.4293 48.8944 23.1253 47.889 22.517C46.8837 21.9087 46.108 21.0736 45.5619 20.0113C45.0246 18.9405 44.756 17.7198 44.756 16.3491C44.756 14.9699 45.0333 13.7491 45.5879 12.6869C46.1513 11.6161 46.927 10.7765 47.915 10.1684C48.903 9.55161 50.0384 9.24316 51.3212 9.24316C52.6386 9.24316 53.7913 9.543 54.7793 10.1427C55.7673 10.7423 56.5342 11.5732 57.0804 12.6355C57.6264 13.6891 57.8993 14.9099 57.8993 16.2977V17.1844H47.967C48.0104 18.2894 48.3397 19.1803 48.9551 19.857C49.5704 20.5339 50.4285 20.8723 51.5292 20.8723C52.3525 20.8723 53.0329 20.6967 53.5702 20.3453C54.1076 19.9856 54.4715 19.5144 54.6623 18.9318H57.7304C57.557 19.8143 57.1756 20.5938 56.5864 21.2705C56.0057 21.9474 55.2733 22.4785 54.3892 22.864C53.5052 23.2409 52.5259 23.4293 51.4512 23.4293ZM47.9931 14.9485H54.7533C54.6493 13.9805 54.2938 13.2181 53.6872 12.6612C53.0892 12.0958 52.3178 11.8131 51.3732 11.8131C50.4197 11.8131 49.6441 12.0958 49.0461 12.6612C48.4567 13.2181 48.1056 13.9805 47.9931 14.9485Z'
          fill='#65558F'
        />
        <path
          d='M56.1785 6.91721V3.97461H71.662V6.91721H65.6558V23.1208H62.2107V6.91721H56.1785Z'
          fill='#65558F'
        />
        <path
          d='M74.0902 23.4293C72.7209 23.4293 71.5335 23.1253 70.5282 22.517C69.5227 21.9087 68.7471 21.0736 68.2011 20.0113C67.6637 18.9405 67.395 17.7198 67.395 16.3491C67.395 14.9699 67.6724 13.7491 68.2271 12.6869C68.7905 11.6161 69.5662 10.7765 70.5542 10.1684C71.5422 9.55161 72.6776 9.24316 73.9603 9.24316C75.2776 9.24316 76.4303 9.543 77.4183 10.1427C78.4064 10.7423 79.1734 11.5732 79.7194 12.6355C80.2654 13.6891 80.5385 14.9099 80.5385 16.2977V17.1844H70.6062C70.6494 18.2894 70.9788 19.1803 71.5942 19.857C72.2096 20.5339 73.0675 20.8723 74.1682 20.8723C74.9917 20.8723 75.6719 20.6967 76.2094 20.3453C76.7466 19.9856 77.1107 19.5144 77.3014 18.9318H80.3695C80.1962 19.8143 79.8148 20.5938 79.2254 21.2705C78.6447 21.9474 77.9123 22.4785 77.0283 22.864C76.1444 23.2409 75.1649 23.4293 74.0902 23.4293ZM70.6322 14.9485H77.3923C77.2884 13.9805 76.933 13.2181 76.3263 12.6612C75.7284 12.0958 74.957 11.8131 74.0122 11.8131C73.0589 11.8131 72.2833 12.0958 71.6852 12.6612C71.0959 13.2181 70.7448 13.9805 70.6322 14.9485Z'
          fill='#65558F'
        />
        <path
          d='M88.1235 23.4293C86.7887 23.4293 85.6144 23.1295 84.6003 22.5298C83.595 21.9302 82.8106 21.0993 82.2473 20.037C81.6926 18.9748 81.4153 17.7455 81.4153 16.3491C81.4153 14.9527 81.6926 13.7234 82.2473 12.6612C82.8106 11.5904 83.595 10.7552 84.6003 10.1555C85.6144 9.54723 86.7887 9.24316 88.1235 9.24316C89.2762 9.24316 90.3032 9.46592 91.2045 9.9113C92.106 10.3482 92.8296 10.9565 93.3756 11.736C93.9303 12.507 94.2553 13.3979 94.3507 14.4088H91.1395C91.0183 13.6807 90.7019 13.0895 90.1905 12.6355C89.6879 12.1729 89.0118 11.9417 88.1625 11.9417C87.0878 11.9417 86.2471 12.3399 85.6404 13.1366C85.0337 13.9334 84.7304 15.0041 84.7304 16.3491C84.7304 17.6855 85.0337 18.752 85.6404 19.5487C86.2471 20.3369 87.0878 20.7308 88.1625 20.7308C89.0205 20.7308 89.6879 20.5081 90.1645 20.0627C90.6412 19.6087 90.9576 19.0047 91.1135 18.2509H94.3507C94.2727 19.2445 93.9563 20.1312 93.4016 20.9108C92.8556 21.6903 92.1275 22.3071 91.2175 22.7612C90.3162 23.2066 89.2849 23.4293 88.1235 23.4293Z'
          fill='#65558F'
        />
        <path
          d='M99.1137 15.4495V23.1208H95.838V3.97461H99.1137V11.5432C100.068 10.0354 101.455 9.28159 103.274 9.28159C104.714 9.28159 105.888 9.73995 106.797 10.6565C107.716 11.5731 108.176 12.9009 108.176 14.6399V23.1208H104.886V15.1539C104.886 14.1602 104.644 13.4064 104.158 12.8924C103.672 12.3785 102.993 12.1214 102.117 12.1214C101.259 12.1214 100.545 12.3869 99.972 12.9181C99.4008 13.4492 99.1137 14.2931 99.1137 15.4495Z'
          fill='#65558F'
        />
        <path
          d='M113.527 23.1208L116.984 13.5477L120.443 3.97461H124.759L131.649 23.1208H127.866L126.319 18.5464H118.805L117.218 23.1208H113.527ZM119.766 15.7579H125.383L124.472 13.0594C124.187 12.177 123.892 11.2562 123.588 10.2967C123.294 9.33721 122.965 8.25363 122.601 7.04571C122.237 8.25363 121.903 9.33721 121.6 10.2967C121.296 11.2562 120.997 12.177 120.703 13.0594L119.766 15.7579Z'
          fill='#65558F'
        />
        <path d='M135.264 3.97461V23.1208H131.833V3.97461H135.264Z' fill='#65558F' />
      </g>
    </svg>
  )
}
